/**
 * Created by dyc on 2018/4/12.
 */
import React from 'react';
import Reflux from 'reflux';
import {
    Button,
    Row,
    Col,
    Modal,
    Input,
    message,
    Select,
    InputNumber,
    DatePicker,
    Table,
    Icon,
    Upload,
    Card,
    Tooltip,
    Cascader,
    Checkbox,
    Tag,
    Notification,
    Progress
} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice, APIS, downLoadTemplate, toImportExcel1} from 'Utils';
import {
    getPro,
    getPro5,
    getPro6,
    giveTeJia,
    giveTeJia2,
    create2,
    getPro4,
    getDetail,
    getTiAddress,
    getDongList,
    getOrderDetails,
    createForSave,
    giveBefore,
    getReserve, updateOrderLineAttribute
} from '../../service/order';
import moment from 'moment';
import './order.css';
import fenPi from './fenpi.png';
import {getGdList} from '../../service/shoppingCar';
import {treeList2} from "../../service/org";

const Option = Select.Option;
const confirm = Modal.confirm;
const {TextArea} = Input;

class CustomOrderAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            button_limits_end: {},
            passId: '',
            /*获取登录人信息数据*/
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || '',
            /*获取详情所需code*/
            purchaseId: JSON.parse(window.sessionStorage.getItem('purchaseId') || '{}') || '',
            /*获取生成订单数据*/
            orderData: JSON.parse(window.sessionStorage.getItem('generate_orders') || '{}') || '',
            /*获取订单商品列表*/
            orderListData: JSON.parse(window.sessionStorage.getItem('list_orders') || '[]') || [],
            passParse: JSON.parse(window.sessionStorage.getItem('passParse') || '{}') || '',
            /*获取预定制列表*/
            dingPassParse: JSON.parse(window.sessionStorage.getItem('dingPassParse') || '{}') || '',
            opts: ['订单详情 -- 新增项目订单'],
            channelCode: JSON.parse(window.sessionStorage.getItem('generate_orders')) ? JSON.parse(window.sessionStorage.getItem('generate_orders')).channelCode : '',
            deliveryShowprice: JSON.parse(window.sessionStorage.getItem('generate_orders')) ? JSON.parse(window.sessionStorage.getItem('generate_orders')).deliveryShowprice : '',
            orderSubmit3: 'block',
            orderSubmit2: 'none',
            orderSubmit4: 'none',
            key: 0,
            visible: false,
            visible3: false,
            visible4: false,
            usable: false,
            modalVisible: false,
            finishTeLoad: false,//编辑进去特价加载
            detailData: {},    //获取的用户信息
            optionAddress: [],    //获取的收货地址（下拉选择）
            tiAddress: [],    //获取的提货地址（下拉选择）
            optionTerminal: [],    //获取的项目信息（含终端）（下拉选择）
            remark: '',    //输入的备注信息
            remark11: '',    //输入的备注信息
            remark22: '',    //输入的备注信息
            remark33: '',    //输入的备注信息
            remark44: '',    //输入的备注信息
            valueRemark: [],    //输入的备注信息
            viewCount: '',
            customerOrderCode: '',      //输入的客户订单号
            gatherRealityAddress: '',  //实际收货地址选中
            tiAddress2: '',
            projectMessage: '',     //项目信息（含终端）选中
            addRows: [],
            addRows3: [],
            addRows4: [],
            addRows5: [],
            addTotal: 1,
            addTotal3: 1,
            addTotal5: 1,
            addTotal10: 1,
            selectedRowKeys: [],
            selectedRowKeys3: [],
            selectedRowKeys4: [],
            selectedRowKeys5: [],
            selectedRowKeysOutside: [],
            name: '',
            code: '',
            stockType: '',
            //李新增
            lastsearch: '',
            addSearchObj: {
                s: 10,
                p: 1
            },
            addSearchObj3: {
                s: 5,
                p: 1,
                proDetailType: null
            },
            addSearchObj4: {
                s: 5,
                p: 1
            },
            addSearchObj5: {
                s: 10,
                p: 1
            },
            addSearchObj10: {
                s: 10,
                p: 1
            },
            submitRows: [],
            add: [],
            rows: [],
            total: 1,
            searchObj: {
                s: 10,
                p: 1
            },
            day: [],
            productionCycle: [],
            date: [],
            xiaFuJia: [],
            weiFaYunCount: [],
            gfjyzr: [],
            jcxf: [],
            // productionCycle:[],
            tehzr: [],
            tehzr2: [],
            tgzr: [],
            tihzr: [],
            tpzr: [],
            xfxzr: [],
            xszr: [],
            zzzr: [],
            defDeliverDay: [],
            productName: [],
            // productionCycle: [],
            cadreRepertory: [],
            onhand: [],
            reserveLineId: [],
            reserveQuantity: [],
            xinzengShow: true,
            xinzengShow1: true,
            teJiaShow: false,
            shouHuoShow: false,
            allPrice: 0,
            realyPrice: 0,
            cutPrice: 0,
            gatherRealityAddress2: '',  //实际收货地址选中
            dataSource2: [],
            number2: 1,
            count2: 1,
            informationProps: {
                /* 产品资料 */
                name: 'file',
                action: APIS.upload,
                headers: {
                    authorization: 'authorization-text',
                },
                onChange: this.updateInformation.bind(this),
                // showUploadList: false,
                // defaultFileList: [],
                data: {
                    id: '-999',
                    dealType: '999',
                }
            },
            informationLi: [],
            loading: false,
            id6: false,
            giveBackStatus: 0,
            dlType: '',
            reserveHid: '',
            confirmvisible: false,
            confirmLoading: false,
            tjlist: [],
            quickVisible: false,
            quickString: '',//智能输入内容
            quickResult: [],
            quickLoading: false,
            // disabledCount:false,
            cascaderValue: [],
            cascaderValue2: [],
            tree: [],
            ts_disabled: false,
            ts_checked: false,
            ls_checked: false,
            proDetailType: "",
            apiFlag: true,
            reserveFlag: false,
            getTjList: [],
            getReserveList: [],
            reserveList: [],
            specCode: '',
            wholeDelivery: 'N', //整单发货
            terminalOrderFlag: '',//项目订单开单权限
            businessLines: [],//业务线集合
            cooperateBusiness: '', //配合业务线
            zdBusiness: '',//终端业务线
            projectBusiness: '',//项目业务线
            finalBusiness: '',//众业达单位业务线
            finishCount: 0,
            postCount: 1,
            selectEscrowFlag: JSON.parse(window.sessionStorage.getItem('generate_orders') || '{}').selectEscrowFlag || 'N'
        };
        this.price = this.price.bind(this);
        this.refreshList = this.refreshList.bind(this);
    };

    quickChange = (event) => {
        this.setState({
            quickString: event.target.value
        });
    }

    handleCancel6 = () => {
        this.setState({quickVisible: false});
    }

    getData() {
        treeList2('').then(result => {
            if (result.status) {
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].code;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }
                this.setState({
                    tree: result.data
                })
            } else {
                openNotice('warning', result.message);
            }
        })
    }

    CascaderClick() {
        if (this.state.tree == null || this.state.tree == '') {
            this.getData();
        }
    }

    CascaderRender = (label) => {
        return label[label.length - 1];
    }


    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    }

    CascaderChange = (value, selectedOptions) => {
        if (value.length > 0) {
            this.setState({
                proDetailType: selectedOptions[2].value,
                proDetailName: selectedOptions[2].label,
                cascaderValue: value,
                addSearchObj: {...this.state.addSearchObj, p: 1}
            });
        } else {
            this.setState({proDetailType: "", proDetailName: "", cascaderValue: []});
        }
    }

    CascaderChange2 = (value, selectedOptions) => {
        if (value.length > 0) {
            this.setState({
                cascaderValue2: value,
                addSearchObj3: {...this.state.addSearchObj3, p: 1, proDetailType: selectedOptions[2].value}
            });
        } else {
            this.setState({addSearchObj3: {...this.state.addSearchObj3, proDetailType: null}, cascaderValue2: []});
        }
    }


    refreshList = () => {
        this.setState({
            usable: true,
        });
        var postCount = 0;
        var finishCount = 0;
        var submitRows = this.state.submitRows;
        submitRows.forEach(() => {
            postCount++;
        });

        this.setState({
            postCount: postCount
        });

        submitRows.forEach((row, index) => {

            setTimeout(() => {
                var postList = {
                    channelCode: this.state.orderData.channelCode,
                    customerId: parseInt(this.state.orderData.thirdId),
                    purchaseId: this.state.detailData.id,
                    pickProAddress: this.state.submitRows[index].pickProAddress,
                    pickProAddressId: this.state.submitRows[index].delvId,
                    proId: this.state.submitRows[index].productId,
                    count: this.state.submitRows[index].count || 0,
                    receiveAddressId: this.state.receiveAddressId
                };

                getDongList(postList).then(res => {
                    if (res.code == 200 && res.data) {
                        finishCount++;
                        this.setState({
                            finishCount: finishCount,
                        });
                        if (postCount == finishCount) {
                            this.setState({
                                usable: false,
                            });
                        }
                        var day = this.state.day;
                        var productionCycle = this.state.productionCycle;
                        var date = this.state.date;
                        var xiaFuJia = this.state.xiaFuJia;
                        var weiFaYunCount = this.state.weiFaYunCount;
                        var gfjyzr = this.state.gfjyzr;
                        var jcxf = this.state.jcxf;
                        var tehzr = this.state.tehzr;
                        var tehzr2 = this.state.tehzr2;
                        var tgzr = this.state.tgzr;
                        var tihzr = this.state.tihzr;
                        var tpzr = this.state.tpzr;
                        var xfxzr = this.state.xfxzr;
                        var xszr = this.state.xszr;
                        var zzzr = this.state.zzzr;
                        var onhand = this.state.onhand;
                        var defDeliverDay = this.state.defDeliverDay;
                        var productName = this.state.productName;
                        var cadreRepertory = this.state.cadreRepertory;
                        var reserveLineId = this.state.reserveLineId;
                        var reserveQuantity = this.state.reserveQuantity;
                        day[index] = res.data.day;
                        date[index] = res.data.date;
                        xiaFuJia[index] = res.data.xiaFuJia;
                        weiFaYunCount[index] = res.data.weiFaYunCount;
                        productionCycle[index] = res.data.productionCycle;
                        gfjyzr[index] = res.data.gfjyzr;
                        jcxf[index] = res.data.jcxf;
                        tehzr[index] = res.data.tehzr;
                        tehzr2[index] = res.data.tehzr2;
                        tgzr[index] = res.data.tgzr;
                        tihzr[index] = res.data.tihzr;
                        tpzr[index] = res.data.tpzr;
                        xfxzr[index] = res.data.xfxzr;
                        xszr[index] = res.data.xszr;
                        zzzr[index] = res.data.zzzr;
                        onhand[index] = res.data.onhand;
                        cadreRepertory[index] = res.data.cadreRepertory;
                        defDeliverDay[index] = res.data.defDeliverDay;
                        productName[index] = res.data.productName;
                        reserveLineId[index] = res.data.reserveLineId;
                        reserveQuantity[index] = res.data.reserveQuantity;
                        /*if (res.data.date == '待评审') {
                            submitRows[index].deliveryArrivalDate = null;
                        } else {
                            submitRows[index].deliveryArrivalDate = submitRows[index].deliveryArrivalDate && submitRows[index].capacityControl == 1 ? submitRows[index].deliveryArrivalDate : res.data.date;
                        }*/
                        submitRows[index].xiaFuJia = res.data.xiaFuJia;
                        submitRows[index].onhand = res.data.onhand;
                        submitRows[index].cadreRepertory = res.data.cadreRepertory;
                        submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                        submitRows[index].productionCycle = res.data.productionCycle;
                        submitRows[index].day = res.data.day;
                        submitRows[index].date = res.data.date;
                        submitRows[index].showPrice = res.data.listPrice;
                        if (submitRows[index].reserveLid == null || submitRows[index].reserveLid == "") {
                            if (res.data.reserveLineId != "") {
                                if (res.data.reserveQuantity < submitRows[index].count) {
                                    submitRows[index].reserveLid = null;
                                } else {
                                    submitRows[index].reserveLid = res.data.reserveLineId;
                                }
                            }
                        }
                        this.setState({
                            day: day,
                            productionCycle: productionCycle,
                            date: date,
                            onhand: onhand,
                            xiaFuJia: xiaFuJia,
                            weiFaYunCount: weiFaYunCount,
                            gfjyzr: gfjyzr,
                            jcxf: jcxf,
                            tehzr: tehzr,
                            tehzr2: tehzr2,
                            tgzr: tgzr,
                            tihzr: tihzr,
                            tpzr: tpzr,
                            xfxzr: xfxzr,
                            xszr: xszr,
                            zzzr: zzzr,
                            defDeliverDay: defDeliverDay,
                            productName: productName,
                            reserveLineId: reserveLineId,
                            reserveQuantity: reserveQuantity,
                            submitRows: submitRows
                        }, () => {
                            this.price();
                        })
                    } else {
                        console.log(res);
                    }
                })
            }, (index + 1) * 800);
        })
    }

    handleOk6 = () => {
        if (this.state.quickString.length == 0) {
            this.setState({quickVisible: false, quickLoading: false, quickString: ''});
            return;
        }
        var rowcount = 0;
        var finshcount = 0;
        this.setState({quickLoading: true, quickResult: []});
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                rowcount++;
            }
        });
        this.state.quickString.split(/[\n]/).forEach(item => {
            if (item.trim().length > 0) {
                var searchItem;
                var count = null;
                if (item.trim().indexOf(",") > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf(","));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf(",") + 1))) {
                        count = item.trim().substr(item.trim().indexOf(",") + 1);
                    }
                } else if (item.trim().indexOf(' ') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf(' '));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf(' ') + 1))) {
                        count = item.trim().substr(item.trim().indexOf(' ') + 1);
                    }
                } else if (item.trim().indexOf('\t') > 0) {
                    searchItem = item.trim().substr(0, item.trim().indexOf('\t'));
                    var re = /^[0-9]+$/g;
                    if (re.test(item.trim().substr(item.trim().indexOf('\t') + 1))) {
                        count = item.trim().substr(item.trim().indexOf('\t') + 1);
                    }
                } else {
                    searchItem = item.trim();
                }
                getPro({
                    channelCode: this.state.orderData.channelCode,
                    customerId: this.state.orderData.thirdId,
                    name: searchItem,
                    stockType: this.state.stockType,
                    p: 1,
                    s: 1
                }).then(result => {
                    finshcount++;
                    if (result.status && result.code == 200) {
                        if (result.total > 0) {
                            if (result.data[0].itemManagerFlag == 'Y' && result.data[0].orderManagerFlag == 'Y') {
                                result.data[0].count = count;
                                //this.addSave(result.data[0], null, null);
                                const quickResult = this.state.quickResult;
                                quickResult.push(result.data[0]);
                            }
                        }
                    } else {
                        message.error(result.message);
                        this.setState({quickLoading: false});
                    }
                    if (rowcount == finshcount) {
                        this.state.quickString.split(/[\n]/).forEach(item => {
                            if (item.trim().length > 0) {
                                const quickResult = this.state.quickResult;
                                quickResult.forEach(item2 => {
                                    var searchItem;
                                    if (item.trim().indexOf(',') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf(','));
                                    } else if (item.trim().indexOf(' ') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf(' '));
                                    } else if (item.trim().indexOf('\t') > 0) {
                                        searchItem = item.trim().substr(0, item.trim().indexOf('\t'));
                                    } else {
                                        searchItem = item.trim();
                                    }
                                    if (item2.itemNum == searchItem) {
                                        this.addSave(item2, null, null);
                                    }
                                })
                            }
                        });
                        this.refreshList();
                        this.setState({quickVisible: false, quickLoading: false, quickString: '', quickResult: []});
                    }
                })
            }
        });
    }

    /*智能录入弹窗*/
    quickHandler = (event) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return
        }
        if (!this.state.orgId || this.state.orgId == '') {
            openNotice('warning', '请先选择提货地点');
            return
        }
        this.setState({quickVisible: true});
    }

    deleteHandler = () => {
        const self = this;
        var selectedRowKeys = this.state.selectedRowKeysOutside;
        if (this.state.selectedRowKeysOutside == '') {
            openNotice('warning', '请确认删除的商品');
            return
        }

        self.setState({
            ...self.state,
            selectedRowKeys: [],
            submitRows: self.state.submitRows.filter(x => selectedRowKeys.indexOf(x.id) === -1),
        }, () => {
            self.price();
        })
        for (let i = 0; i < selectedRowKeys.length; i++) {
            var day = self.state.day;
            var date = self.state.date;
            var xiaFuJia = self.state.xiaFuJia;
            var weiFaYunCount = self.state.weiFaYunCount;
            var cadreRepertory = self.state.cadreRepertory;
            var onhand = self.state.onhand;
            var productionCycle = self.state.productionCycle;
            var defDeliverDay = self.state.defDeliverDay;
            var productName = self.state.productName;
            var gfjyzr = self.state.gfjyzr;
            var jcxf = self.state.jcxf;
            var tehzr = self.state.tehzr;
            var tehzr2 = self.state.tehzr2;
            var tgzr = self.state.tgzr;
            var tihzr = self.state.tihzr;
            var tpzr = self.state.tpzr;
            var xfxzr = self.state.xfxzr;
            var xszr = self.state.xszr;
            var zzzr = self.state.zzzr;
            var reserveLineId = self.state.reserveLineId;
            var reserveQuantity = self.state.reserveQuantity;

            day.splice([selectedRowKeys[i] - 1], 1);
            date.splice([selectedRowKeys[i] - 1], 1);
            xiaFuJia.splice([selectedRowKeys[i] - 1], 1);
            weiFaYunCount.splice([selectedRowKeys[i] - 1], 1);
            cadreRepertory.splice([selectedRowKeys[i] - 1], 1);
            onhand.splice([selectedRowKeys[i] - 1], 1);
            productionCycle.splice([selectedRowKeys[i] - 1], 1);
            defDeliverDay.splice([selectedRowKeys[i] - 1], 1);
            productName.splice([selectedRowKeys[i] - 1], 1);
            reserveLineId.splice([selectedRowKeys[i] - 1], 1);
            reserveQuantity.splice([selectedRowKeys[i] - 1], 1);

            gfjyzr.splice([selectedRowKeys[i] - 1], 1);
            jcxf.splice([selectedRowKeys[i] - 1], 1);
            tehzr.splice([selectedRowKeys[i] - 1], 1);
            tehzr2.splice([selectedRowKeys[i] - 1], 1);
            tgzr.splice([selectedRowKeys[i] - 1], 1);
            tihzr.splice([selectedRowKeys[i] - 1], 1);
            tpzr.splice([selectedRowKeys[i] - 1], 1);
            xfxzr.splice([selectedRowKeys[i] - 1], 1);
            xszr.splice([selectedRowKeys[i] - 1], 1);
            zzzr.splice([selectedRowKeys[i] - 1], 1);
            self.setState({
                day: day,
                date: date,
                xiaFuJia: xiaFuJia,
                weiFaYunCount: weiFaYunCount,
                onhand: onhand,
                cadreRepertory: cadreRepertory,
                productionCycle: productionCycle,
                defDeliverDay: defDeliverDay,
                productName: productName,
                reserveLineId: reserveLineId,
                reserveQuantity: reserveQuantity,

                gfjyzr: gfjyzr,
                jcxf: jcxf,
                tehzr: tehzr,
                tehzr2: tehzr2,
                tgzr: tgzr,
                tihzr: tihzr,
                tpzr: tpzr,
                xfxzr: xfxzr,
                xszr: xszr,
                zzzr: zzzr,
            })
        }
    };

    /*下载模板*/
    downloadChange() {
        downLoadTemplate(4);
    }

    /*上传附件*/
    updateInformation(result) {
        let informationLi = this.state.informationLi || [];
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            informationLi.push({
                id: responseData.data.id,
                fileName: responseData.data.fileName,
            });
        }
        this.setState({
            informationLi: informationLi
        })
    }

    deleteInformation(index) {
        /* 删除产品资料 */
        const {informationLi} = this.state;
        informationLi.splice(index, 1);
        this.setState({
            informationLi: informationLi
        });
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    }

    /*返回*/
    goBack() {
        // hashHistory.goBack();
        this.goView('order');
    };

    /*选择外层列表*/
    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeysOutside: selectedRowKeys});
    };
    /*外层翻页*/
    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            this.initData();
        });
    };
    /*选择物料弹窗*/
    searchHandler = (event) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return
        }
        this.setState({visible: true});
        // this.getAddArray();
    };
    openModal = (record, index, event) => {
        var getList = this.state.submitRows[index].orderProductPartList || [];
        var x = this.state.submitRows[index].productName;
        this.setState({dataSource2: getList, dataSource3: index, productName2: x});
        this.setState({modalVisible: true});
    }
    /*选择物料列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        const self = this;
        var add = [];
        add = [...selectedRows];
        for (let i = 0; i < selectedRows.length; i++) {
            add[i].pickProAddress = self.state.tiAddress2;
            add[i].productName = selectedRows[i].name;
            add[i].productId = selectedRows[i].id;
            giveTeJia({
                customerId: parseInt(self.state.orderData.thirdId),
                proId: selectedRows[i].id,
                purchaseId: self.state.detailData.id,
                channelCode: self.state.orderData.channelCode,
                flowCode: self.state.guiShu1,
            }).then(result => {
                add[i].terminalPriceRate = result.data.terminalPriceRate;
                add[i].terminalPriceRate1 = result.data.terminalPriceRate;
                add[i].terminalUnitPrice = result.data.terminalUnitPrice;
                add[i].terminalUnitPrice1 = result.data.terminalUnitPrice;
                if (result.data.terminalPriceRate == '' && result.data.terminalUnitPrice == '') {
                    add[i].specialFlag = 0;
                } else {
                    add[i].specialFlag = 1;
                }
                add[i].offerLineId = result.data.offerLineId;
                if (result.data.quantity != null) {
                    add[i].quantity = result.data.quantity;
                    add[i].countMax = result.data.quantity;
                }
            })
        }
        self.setState({
            selectedRowKeys: selectedRowKeys,
            add: add
        })
    };
    onSelectRadio = (record, selected, selectedRows) => {
        this.setState({
            pId: record.id,
            pListId: record.priceListId,
        })
    }
    onSelectRadio5 = (record, selected, selectedRows) => {
        // // debugger
        this.setState({
            contractOrderCode: record.contractOrderCode,
            contractOrderName: record.contractOrderName,
            contractId: record.contractId,
            guaranteeQuality: record.guaranteeQuality,
        })
    }
    /*选择物料列表翻页*/
    addPageChange = (page, pageSize) => {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, function () {
            this.getAddArray();
        });
    };
    addPageChange4 = (page, pageSize) => {
        this.setState({addSearchObj4: {...this.state.addSearchObj4, s: pageSize, p: page}}, function () {
            this.getAddArray4();
        });
    };
    addPageChange5 = (page, pageSize) => {
        this.setState({addSearchObj5: {...this.state.addSearchObj5, s: pageSize, p: page}}, function () {
            this.getAddArray5();
        });
    };

    /*选择物料-物料编码搜索*/
    codeChange = (event) => {
        this.setState({
            code: event.target.value
        });
    };
    /*选择物料-物料名称搜索*/
    nameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    };

    tsChange = (e) => {
        this.setState({
            stockType: e.target.checked ? "退市" : "",
            ts_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1}
        });
    }
    lsChange = (e) => {
        this.setState({
            ls_checked: e.target.checked,
            addSearchObj: {...this.state.addSearchObj, p: 1}
        });
    }

    //物料查询界面库存搜索
    stockChange = (value) => {
        switch (value) {
            case '0':
                this.setState({
                    stockType: '库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '1':
                this.setState({
                    stockType: '非库存',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '2':
                this.setState({
                    stockType: '定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '3':
                this.setState({
                    stockType: '专属定制',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            case '4':
                this.setState({
                    stockType: '退市',
                    ts_disabled: true,
                    ts_checked: false,
                });
                break;
            default :
                this.setState({
                    stockType: '',
                    ts_disabled: false,
                    ts_checked: false,
                });
                break;
        }
    }
    /*选择物料列表数据(点击搜索)*/
    getAddArray = () => {
        if (this.state.name == '') {
            openNotice('warning', '请输入物料名称或编码');
            return
        }
        const self = this;
        if (this.state.name != this.state.lastsearch) {
            this.state.addSearchObj.p = 1;
            this.state.lastsearch = this.state.name;
        }
        this.setState({loading: true});
        getPro({
            channelCode: this.state.orderData.channelCode,
            customerId: this.state.orderData.thirdId,
            keyword: this.state.code,
            name: this.state.name,
            stockType: this.state.stockType,
            proDetailType: this.state.proDetailType,
            proDetailName: this.state.proDetailName,
            delisting: this.state.ts_checked,
            historyOpen: this.state.ls_checked,
            businessLines: this.state.businessLines,
            p: this.state.addSearchObj.p,
            s: this.state.addSearchObj.s
        }).then(result => {
            if (result.status && result.code == 200) {
                self.setState({
                    addRows: result.data,
                    addTotal: result.total,
                    loading: false
                });
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })
    };

    keypress = (e) => {
        if (e.which == 13) {
            this.getAddArray();
        }
    }

    //特价行翻页数据
    getAddArray4 = () => {
        //李 新增
        //分页查询在只有将页码赋值到第一页才能在当前页查询不同页码内的数据
        if (this.state.specCode1 != this.state.lastsearch) {
            this.state.addSearchObj4.p = 1;
            this.state.lastsearch = this.state.specCode1;
        }
        getPro5({
            specCode: this.state.specCode1,
            p: this.state.addSearchObj4.p,
            s: this.state.addSearchObj4.s
        }).then(result => {
            if (result.status && result.code == 200) {
                // debugger
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows4: data,
                    addTotal4: result.total,
                    // tiAddress: result,
                });
            } else {
                message.error(result.message);
            }
        })

    };

    addSaveHandler3 = () => {
        const self = this;
        if (this.state.selectedRowKeys3.length === 0) {
            openNotice('warning', '请选择至少一条列表数据');
            return;
        }
        /*确认*/
        this.doSave3();
        /*清空信息*/
        this.doClear3();
        this.setState({
            teJiaShow: true,
        }, () => {
            if (this.state.teJiaShow == true && this.state.shouHuoShow == true) {
                this.setState({xinzengShow: false, xinzengShow1: false}, () => {
                    if (this.props.params.id == 6) {
                        this.setState({xinzengShow1: true})
                    }
                });
                for (let i = 0; i < self.state.submitRows.length; i++) {
                    giveTeJia({
                        customerId: parseInt(self.state.orderData.thirdId),
                        proId: self.state.submitRows[i].productId,
                        purchaseId: self.state.detailData.id,
                        channelCode: self.state.orderData.channelCode,
                        flowCode: self.state.guiShu1,
                    }).then(result => {
                        var submitRows = {...this.state.submitRows};
                        submitRows[i].terminalPriceRate = result.data.terminalPriceRate;
                        submitRows[i].terminalPriceRate1 = result.data.terminalPriceRate;
                        submitRows[i].terminalUnitPrice = result.data.terminalUnitPrice;
                        submitRows[i].terminalUnitPrice1 = result.data.terminalUnitPrice;
                        submitRows[i].offerLineId = result.data.offerLineId;
                        if (result.data.terminalPriceRate == '' && result.data.terminalUnitPrice == '') {
                            submitRows[i].specialFlag = 0;
                        } else {
                            submitRows[i].specialFlag = 1;
                        }
                        if (result.data.quantity != null) {
                            submitRows[i].quantity = result.data.quantity;
                            submitRows[i].countMax = result.data.quantity;
                            if (submitRows[i].count > submitRows[i].quantity) {
                                submitRows[i].count = submitRows[i].quantity;
                            }
                        }
                    })
                }
            }
        })
        this.setState({visible3: false});
    }

    clearSaveHandler3 = () => {
        const self = this;
        confirm({
            content: '确定清除价格单号吗?',
            onOk() {
                self.doSave3();
                self.doClear3();
                self.setState({
                    teJiaShow: false,
                    guiShu1: null,
                    specCode1: null
                }, () => {
                    for (let i = 0; i < self.state.submitRows.length; i++) {
                        var submitRows = {...self.state.submitRows};
                        submitRows[i].offerLineId = null;
                        submitRows[i].specialFlag = 1;
                    }
                    self.setState({visible3: false});
                })
            },
            onCancel() {
                return
            }
        })
    }

    addSaveHandler4 = () => {
        if (this.state.selectedRowKeys5.length === 0) {
            openNotice('warning', '请选择至少一条列表数据');
            return;
        }
        /*确认*/
        this.doSave4();
        /*清空信息*/
        this.doClear4();
        this.setState({visible4: false});
    }


    openAdd = (proCode) => {
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return
        }
        this.setState({visible: true, name: proCode}, () => {
            this.getAddArray()
        });
    }

    /*添加行*/
    addSave = (record, index, value) => {
        const self = this;
        // var x = 0;
        // for ( var i = 0 ; i < this.state.submitRows.length ;i++) {
        // 	if(this.state.submitRows[i].productId == record.id || this.state.submitRows[i].productId == record.productId){
        // 		x = 1;
        // 	}
        // }
        // if (x == 1) {
        // 	openNotice('warning', '商品已添加');
        // 	return
        // }
        var submitRows = [...this.state.submitRows];
        var addSave = {...record};
        addSave.productId = addSave.id;
        giveTeJia({
            customerId: parseInt(self.state.orderData.thirdId),
            proId: record.id,
            purchaseId: self.state.detailData.id,
            channelCode: self.state.channelCode,
            flowCode: self.state.guiShu1,
        }).then(result => {
            addSave.terminalPriceRate = result.data.terminalPriceRate;
            addSave.terminalPriceRate1 = result.data.terminalPriceRate;
            addSave.terminalUnitPrice = result.data.terminalUnitPrice;
            addSave.terminalUnitPrice1 = result.data.terminalUnitPrice;
            addSave.offerLineId = result.data.offerLineId;
            if (result.data.terminalPriceRate == '' && result.data.terminalUnitPrice == '') {
                addSave.specialFlag = 0;
            } else {
                addSave.specialFlag = 1;
            }
            if (result.data.quantity != null) {
                addSave.quantity = result.data.quantity;
                addSave.countMax = result.data.quantity;
                if (result.data.quantity != null) {
                    if (addSave.count > result.data.quantity) {
                        addSave.count = result.data.quantity;
                    }
                }
            }
        })
        addSave.id = window.myTemp++;
        if (addSave.count == null) {
            addSave.count = 0;
        }
        addSave.productName = addSave.name;
        if (self.state.orgName) {
            addSave.delvId = self.state.orgId;
            addSave.pickProAddress = self.state.orgName;
        }
        submitRows.push(addSave);
        self.setState({submitRows: submitRows});
        openNotice('success', '商品添加成功', null, 1);
    }
    /*点击确定保存*/
    addSaveHandler = (value) => {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择至少一条物料列表数据');
            return;
        }
        if (this.state.selectedRowKeys.pickProAddress === 0) {
            openNotice('warning', '请选择提货地点');
            return;
        }
        var x = 0;
        for (var i = 0; i < this.state.submitRows.length; i++) {
            for (var j = 0; j < this.state.selectedRowKeys.length; j++) {
                if (this.state.submitRows[i].productId == this.state.selectedRowKeys[j]) {
                    x = 1;
                }
            }
        }
        // if (x == 1) {
        // 	openNotice('warning', '商品已添加');
        // 	return
        // }
        //  var x = 0;
        //  for (var i = 0 ; i < this.state.submitRows.length; i++) {
        //  	if (this.state.submitRows[i].productId == this.state.selectedRowKeys.id ) {
        //  		x = 1;
        //  	}
        //  }
        // if (x == 1) {
        //  openNotice('warning', '已存在相同商品');
        //  return;
        //  }
        /*确认*/
        this.doSave(value);
        /*清空信息*/
        this.doClear();
        if (value != 1) {
            this.setState({visible: false});
            this.setState({modalVisible: false});
        }
    }
    doSave = (value) => {
        const self = this;
        var submitRows = [...this.state.submitRows];
        for (let i = 0; i < self.state.add.length; i++) {
            self.state.add[i].id = window.myTemp++;
            self.state.add[i].count = 0; //TODO
            if (self.state.orgName) {
                self.state.add[i].delvId = self.state.orgId;
                self.state.add[i].pickProAddress = self.state.orgName;
            }
            submitRows.push(self.state.add[i]);
        }
        self.setState({submitRows: submitRows});
        if (value != 1) {
            self.setState({visible: false});
            self.setState({modalVisible: false});
        }
    }
    doSave3 = () => {
        this.setState({visible3: false});
    };
    doSave4 = () => {
        this.setState({visible4: false});
    };
    doClear3 = () => {
        this.setState({
            guiShu: '',
            selectedRowKeys3: [],
        });
    };
    doClear4 = () => {
        this.setState({
            guiShu: '',
            selectedRowKeys4: [],
        });
    };
    doClear = () => {
        this.setState({
            name: '',
            code: '',
            add: {
                ...this.state.add,
            },
            selectedRowKeys: [],
        });
    };
    /*点击保存提交数据*/
    createHandler = (value) => {
        var self = this;
        self.setState({confirmLoading: true});
        if (this.state.terminalOrderFlag == 'N') {
            openNotice('warning', '该单位没有项目订单的开单权限');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        if (this.state.channelCode == 'DL' && this.state.remark22 == '') {
            openNotice('warning', '电力渠道结算对应号必填');
            self.setState({confirmvisible: false, confirmLoading: false});
            return;
        }
        self.setState({usable: true});
        var userData = this.state.userData;
        var orderData = this.state.orderData;
        var detailData = this.state.detailData;
        var createObj = {};
        createObj = {
            "amount": this.state.allPrice,
            "buyCompany": orderData.PurchaseUnit,
            "channel": orderData.channel,
            "specialOfferCode": this.state.specCode1 || '',
            "completeFactory": this.state.remark11,
            "closeHomologous": this.state.remark22,
            "projectAddMsg": this.state.remark33,
            "projectCooperation": this.state.projectCooperation,
            "contractNum": this.state.contractOrderCode,
            "contractOrderName": this.state.contractOrderName,
            "contractId": this.state.contractId,
            "contacts": this.state.recipientName,
            "createdDate": detailData.createdDate,
            "creditExtensionMode": this.state.orderData.pay,//授信方式(项目订单)
            "cusId": orderData.thirdId,
            "customerCode": detailData.cusCode,
            "customerName": detailData.cusName,
            "customerOrderCode": this.state.customerOrderCode,
            "discountRate": orderData.defDiscount,
            "gatherRealityAddress": this.state.gatherRealityAddress || '',
            "guaranteeQuality": this.state.guaranteeQuality,
            "orderBackMsg": '',
            "orderType": "2", /*1常规订单2项目订单3合作伙伴订单*/
            "phone": this.state.mobile,
            "projectMessage": this.state.projectMessage || '',
            "projectName": detailData.name,
            "remainingSum": orderData.sxeAmount,
            "remark": this.state.remark,
            "removeFlag": 0,
            "salesmanName": this.state.remark44,
            "pullmanName": this.state.pullmanName,
            "pullChannel": this.state.pullChannel,
            "sellType": "GF ",
            "submitType": 1, /*提交1保存0*/
            "userId": userData.id,
            "buyCompanyId": this.state.detailData.id,
            "gatherAddressId": this.state.receiveAddressId,
            "creditExtensionId": this.state.detailData.id,
            "orgId": 82,
            "isTg": "是否天正订单",
            "businessChannel": "",
            "deliveryShowprice": this.state.deliveryShowprice,
            "discountPoolSum": orderData.discountAmount,
            "realityAmount": this.state.realyPrice,
            "isSecond": 0,
            "channelCode": orderData.channelCode,
            "cusUserId": detailData.cusUserId || '',
            "paymentTermId": orderData.paymentTermId || '',
            "getProCode": this.state.getProCode || '',
            "dlType": this.state.dlType || '',
            "reserveHid": this.state.reserveHid || '',
            "orderSource": orderData.orderSource,
            "wholeDelivery": this.state.wholeDelivery,
            "sourceNo": this.state.sourceNo,
            "escrowFlag": orderData.escrowFlag
        }
        if (!this.state.getProCode) {
            delete createObj.getProCode;
        }
        if (value == 2) {
            createObj.submitType = 2
        }
        if (this.props.params.id == 6) {
            createObj.headerId = this.state.headerId;
            createObj.reserveHid = self.state.reserveHid;
        }
        if (this.props.params.id == 9) {
            createObj.id = this.props.params.orderId;
            if (this.props.params.type && this.props.params.type == '再来一单') {
                createObj.id = '';
                delete createObj.getProCode;
                delete createObj.orderSource;
            }
        }
        var obj2 = JSON.parse(JSON.stringify(this.state.submitRows));
        for (var i = 0; i < this.state.submitRows.length; i++) {
            obj2[i].availableReferenceQuantity = this.state.submitRows[i].onhand; //参考可用量
            obj2[i].price = this.state.submitRows[i].xiaFuJia; //下浮价
            obj2[i].weiFaYunCount = this.state.submitRows[i].weiFaYunCount;
            obj2[i].gfjyzr = this.state.gfjyzr[i];
            obj2[i].jcxf = this.state.jcxf[i];
            obj2[i].productionCycle = this.state.submitRows[i].productionCycle;
            obj2[i].tehzr = this.state.tehzr[i];
            obj2[i].tehzr2 = this.state.tehzr2[i];
            obj2[i].tgzr = this.state.tgzr[i];
            obj2[i].tihzr = this.state.tihzr[i];
            obj2[i].tpzr = this.state.tpzr[i];
            obj2[i].xfxzr = this.state.xfxzr[i];
            obj2[i].xszr = this.state.xszr[i];
            obj2[i].zzzr = this.state.zzzr[i];
            obj2[i].logisticsCycle = this.state.submitRows[i].day;

            if (obj2[i].price == null || obj2[i].price == '') {
                openNotice('error', obj2[i].itemNum + '获取下浮价失败，请删除该行重新添加，或修改数量重新获取下浮价', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                this.setState({usable: false});
                return
            }

            if (obj2[i].delvId == null) {
                openNotice('error', '请选择订单行上的提货地点', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                this.setState({usable: false});
                return
            }
            switch (this.state.submitRows[i].proLine) {
                case  '元器件':
                    obj2[i].proLine = '01';
                    break;
                case  '电工':
                    obj2[i].proLine = '02';
                    break;
                case  '电表':
                    obj2[i].proLine = '03';
                    break;
                case  '变频器':
                    obj2[i].proLine = '04';
                    break;
                case  '天e':
                    obj2[i].proLine = '05';
                    break;
                case  'TG精品':
                    obj2[i].proLine = '06';
                    break;
            }

            obj2[i].referenceArrivalDate = this.state.submitRows[i].date;
            obj2[i].productCode = this.state.submitRows[i].itemNum;
            obj2[i].originalPrice = this.state.submitRows[i].showPrice;
            obj2[i].createdDate = detailData.createdDate;
            obj2[i].createdBy = detailData.createdBy;
            if (this.props.params.id == 9) {
                obj2[i].createdBy = this.state.createdBy;
            }
            if (obj2[i].originalPrice == "" || obj2[i].originalPrice == undefined) {
                openNotice('error', '物料编码：' + obj2[i].productCode + ' 牌价为空，请联系生产计划部，检查物料是否分配到提货物流（' + obj2[i].pickProAddress + '），或面价是否正常。', '');
                this.setState({usable: false});
                return;
            }
            obj2[i].removeFlag = 0;
            obj2[i].terminalPriceRate = this.state.submitRows[i].terminalPriceRate || 0;
            obj2[i].terminalUnitPrice = this.state.submitRows[i].terminalUnitPrice;
            obj2[i].offerLineId = this.state.submitRows[i].offerLineId;
            obj2[i].subinventory = this.state.submitRows[i].subinventory;
            obj2[i].countMax = this.state.submitRows[i].countMax;
            obj2[i].specialFlag = this.state.submitRows[i].specialFlag;
            if (obj2[i].terminalUnitPrice == '' || !obj2[i].terminalUnitPrice) {
                openNotice('error', '请检查终端下浮价', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                self.setState({usable: false});
                return
            }
            delete obj2[i].id;
            delete obj2[i].showPrice;
            delete obj2[i].itemNum;
            if (self.state.submitRows[i].weiFaYunCount && self.state.submitRows[i].weiFaYunCount != 0) {
                var existUnFaYun = 1;
            }
        }
        createObj.productList = obj2;
        var x = 0;
        if (createObj.productList.length > 0) {
            for (var i = 0; i < createObj.productList.length; i++) {
                if (!createObj.productList[i].count) {
                    x = 1;
                }
            }
        }
        let informationLi = this.state.informationLi || [];
        let fileId = '';
        for (var i = 0; i < informationLi.length; i++) {
            fileId = fileId + informationLi[i].id + ',';
        }
        createObj.fileId = fileId.substr(0, fileId.length - 1);
        if (self.state.selectedRows5 < self.state.realyPrice) {
            openNotice('error', '合同金额余额不足', '');
            self.setState({confirmvisible: false, confirmLoading: false});
            self.setState({usable: false});
            return;
        }
        if (existUnFaYun == 1) {
            confirm({
                content: '存在未发运数量，是否继续？',
                onOk() {
                    if (createObj.productList.length < 1) {
                        openNotice('error', '请添加商品', '');
                        self.setState({confirmvisible: false, confirmLoading: false});
                        self.setState({usable: false});
                        return
                    } else {
                        if (x == 1) {
                            openNotice('error', '请确认数量', '');
                            self.setState({confirmvisible: false, confirmLoading: false});
                            self.setState({usable: false});
                            return
                        } else {
                            /*if ( self.state.giveBackStatus == 4 ) {
								createObj.headerId = this.state.headerId2;
								giveBefore(createObj).then(result => {
									if (result.status && result.code == 200) {
										openNotice('success', '创建成功', '');
										self.goView('order');
									} else {
										openNotice('error', '创建失败', result.message || '');
										self.setState({usable:false});
										return
									}
								});
							} else {*/
                            create2(createObj).then(result => {
                                if (result.status && result.code == 200) {
                                    updateOrderLineAttribute(result.data.sourceNo);
                                    openNotice('success', '创建成功', '');
                                    self.setState({confirmvisible: false, confirmLoading: false});
                                    self.goView('order');
                                } else {
                                    openNotice('error', '创建失败', result.message || '');
                                    self.setState({confirmvisible: false, confirmLoading: false});
                                    self.setState({usable: false});
                                    return
                                }
                            });
                            //}
                        }
                    }
                },
                onCancel() {
                    self.setState({confirmvisible: false, confirmLoading: false});
                    self.setState({usable: false});
                    return
                },
            });
        } else {
            if (createObj.productList.length < 1) {
                openNotice('error', '请添加商品', '');
                self.setState({confirmvisible: false, confirmLoading: false});
                self.setState({usable: false});
                return
            } else {
                if (x == 1) {
                    openNotice('error', '请确认数量', '');
                    self.setState({confirmvisible: false, confirmLoading: false});
                    self.setState({usable: false});
                    return
                } else {
                    if (self.state.giveBackStatus == 4) {
                        createObj.headerId = this.state.headerId2;
                        giveBefore(createObj).then(result => {
                            if (result.status && result.code == 200) {
                                updateOrderLineAttribute(result.data.sourceNo);
                                openNotice('success', '创建成功', '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.goView('order');
                            } else {
                                openNotice('error', '创建失败', result.message || '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.setState({usable: false});
                                return
                            }
                        });
                    } else {
                        create2(createObj).then(result => {
                            if (result.status && result.code == 200) {
                                updateOrderLineAttribute(result.data.sourceNo);
                                openNotice('success', '创建成功', '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.goView('order');
                            } else {
                                openNotice('error', '创建失败', result.message || '');
                                self.setState({confirmvisible: false, confirmLoading: false});
                                self.setState({usable: false});
                                return
                            }
                        });
                    }
                }
            }
        }
    };


    createHandler2 = (value) => {
        var self = this;
        if (this.state.terminalOrderFlag == 'N') {
            openNotice('warning', '该单位没有项目订单的开单权限');
            return;
        }
        if (!this.state.receiveAddressId || this.state.receiveAddressId == '') {
            openNotice('warning', '请选择实际收货地址');
            return;
        }
        if (this.state.channelCode == 'DL' && this.state.remark22 == '') {
            openNotice('warning', '电力渠道结算对应号必填');
            return;
        }
        self.setState({usable: true});
        var userData = this.state.userData;
        var orderData = this.state.orderData;
        var detailData = this.state.detailData;
        //总金额重新计算
        var price = 0;
        var allPrice = 0;
        var realyPrice = 0;
        var allRealyPrice = 0;
        var everyPrice = 0;
        var everyRealyPrice = 0;
        var everyCount = 0;
        for (var i = 0; i < self.state.submitRows.length; i++) {
            everyCount = self.state.submitRows[i].count || 0;
            everyPrice = self.state.submitRows[i].showPrice || 0;
            everyRealyPrice = self.state.submitRows[i].terminalUnitPrice || 0;
            allPrice = everyCount * everyPrice;
            price = price + allPrice;
            allRealyPrice = everyCount * everyRealyPrice;
            realyPrice = realyPrice + allRealyPrice;
        }
        //存储参数
        var createObj = {};
        createObj = {
            "amount": this.state.allPrice,
            "buyCompany": orderData.PurchaseUnit,
            "channel": orderData.channel,
            "specialOfferCode": this.state.specCode1 || '',
            "completeFactory": this.state.remark11,
            "closeHomologous": this.state.remark22,
            "projectAddMsg": this.state.remark33,
            "salesmanName": this.state.remark44,
            "pullmanName": this.state.pullmanName,
            "pullChannel": this.state.pullChannel,
            "projectCooperation": this.state.projectCooperation,
            "contractNum": this.state.contractOrderCode,
            "contractOrderName": this.state.contractOrderName,
            "contractId": this.state.contractId,
            "contacts": this.state.recipientName,
            "createdDate": detailData.createdDate,
            "creditExtensionMode": this.state.orderData.pay,//付款方式(项目订单) 后端说的
            "cusId": orderData.thirdId,
            "customerCode": detailData.cusCode,
            "customerName": detailData.cusName,
            "customerOrderCode": this.state.customerOrderCode,
            "discountRate": orderData.defDiscount,
            "gatherRealityAddress": this.state.gatherRealityAddress || '',
            "guaranteeQuality": this.state.guaranteeQuality,
            "orderBackMsg": '',
            "orderType": "2", /*1常规订单2项目订单3合作伙伴订单*/
            "phone": this.state.mobile,
            "projectMessage": this.state.projectMessage || '',
            "projectName": detailData.name,
            "remainingSum": orderData.sxeAmount,
            "remark": this.state.remark,
            "removeFlag": 0,
            "sellType": "GF ",
            "submitType": 0, /*提交1保存0*/
            "userId": userData.id,
            "buyCompanyId": this.state.detailData.id,
            "gatherAddressId": this.state.receiveAddressId,
            "creditExtensionId": this.state.detailData.id,
            "orgId": 82,
            "isTg": "是否天正订单",
            "businessChannel": "",
            "deliveryShowprice": this.state.deliveryShowprice,
            "discountPoolSum": orderData.discountAmount,
            "realityAmount": realyPrice,
            "isSecond": 0,
            "channelCode": orderData.channelCode,
            "cusUserId": detailData.cusUserId || '',
            "paymentTermId": orderData.paymentTermId || '',
            "getProCode": this.state.getProCode || '',
            "dlType": this.state.dlType || '',
            "reserveHid": this.state.reserveHid || '',
            "orderSource": orderData.orderSource,
            "wholeDelivery": this.state.wholeDelivery,
            "sourceNo": this.state.sourceNo,
            "escrowFlag": orderData.escrowFlag
        }
        if (!this.state.getProCode) {
            delete createObj.getProCode;
        }
        if (this.props.params.id == 6) {
            createObj.headerId = this.state.headerId;
            createObj.reserveHid = self.state.reserveHid;
        }
        if (this.props.params.id == 9) {
            createObj.id = this.props.params.orderId;
            if (this.props.params.type && this.props.params.type == '再来一单') {
                createObj.id = '';
                delete createObj.getProCode;
            }
        }
        var obj2 = JSON.parse(JSON.stringify(this.state.submitRows));

        for (var i = 0; i < this.state.submitRows.length; i++) {
            obj2[i].availableReferenceQuantity = this.state.submitRows[i].onhand; //参考可用量
            obj2[i].price = this.state.submitRows[i].xiaFuJia; //下浮价
            obj2[i].weiFaYunCount = this.state.submitRows[i].weiFaYunCount; //下浮价
            obj2[i].gfjyzr = this.state.gfjyzr[i];
            obj2[i].jcxf = this.state.jcxf[i];
            obj2[i].productionCycle = this.state.submitRows[i].productionCycle;
            obj2[i].tehzr = this.state.tehzr[i];
            obj2[i].tehzr2 = this.state.tehzr2[i];
            obj2[i].tgzr = this.state.tgzr[i];
            obj2[i].tihzr = this.state.tihzr[i];
            obj2[i].tpzr = this.state.tpzr[i];
            obj2[i].xfxzr = this.state.xfxzr[i];
            obj2[i].xszr = this.state.xszr[i];
            obj2[i].zzzr = this.state.zzzr[i];
            obj2[i].logisticsCycle = this.state.submitRows[i].day;

            if (obj2[i].price == null || obj2[i].price == '') {
                openNotice('error', obj2[i].itemNum + '获取下浮价失败，请删除该行重新添加，或修改数量重新获取下浮价', '');
                this.setState({usable: false});
                return
            }

            if (obj2[i].delvId == null) {
                openNotice('error', '请选择订单行上的提货地点', '');
                this.setState({usable: false});
                return
            }
            switch (this.state.submitRows[i].proLine) {
                case  '元器件':
                    obj2[i].proLine = '01';
                    break;
                case  '电工':
                    obj2[i].proLine = '02';
                    break;
                case  '电表':
                    obj2[i].proLine = '03';
                    break;
                case  '变频器':
                    obj2[i].proLine = '04';
                    break;
                case  '天e':
                    obj2[i].proLine = '05';
                    break;
                case  'TG精品':
                    obj2[i].proLine = '06';
                    break;
            }
            obj2[i].referenceArrivalDate = this.state.submitRows[i].date;
            obj2[i].productCode = this.state.submitRows[i].itemNum;
            obj2[i].originalPrice = this.state.submitRows[i].showPrice;
            obj2[i].createdDate = detailData.createdDate;
            obj2[i].createdBy = detailData.createdBy;
            obj2[i].removeFlag = 0;
            if (this.props.params.id == 9) {
                obj2[i].createdBy = this.state.createdBy;
            }
            if (obj2[i].originalPrice == "" || obj2[i].originalPrice == undefined) {
                openNotice('error', '物料编码：' + obj2[i].productCode + ' 牌价为空，请联系生产计划部，检查物料是否分配到提货物流（' + obj2[i].pickProAddress + '），或面价是否正常。', '');
                this.setState({usable: false});
                return;
            }
            if (obj2[i].terminalUnitPrice == '' || !obj2[i].terminalUnitPrice) {
                openNotice('error', '请检查终端下浮价', '');
                self.setState({usable: false});
                return
            }
            obj2[i].terminalPriceRate = this.state.submitRows[i].terminalPriceRate;
            obj2[i].terminalUnitPrice = this.state.submitRows[i].terminalUnitPrice;
            obj2[i].offerLineId = this.state.submitRows[i].offerLineId;
            obj2[i].subinventory = this.state.submitRows[i].subinventory;
            obj2[i].countMax = this.state.submitRows[i].countMax;
            obj2[i].specialFlag = this.state.submitRows[i].specialFlag;
            delete obj2[i].id;
            delete obj2[i].showPrice;
            delete obj2[i].itemNum;
            if ((self.state.submitRows[i].weiFaYunCount && self.state.submitRows[i].weiFaYunCount != 0)) {
                var existUnFaYun = 1;
            }
        }
        createObj.productList = obj2;
        var x = 0;
        if (createObj.productList.length > 0) {
            for (var i = 0; i < createObj.productList.length; i++) {
                if (!createObj.productList[i].count) {
                    x = 1;
                }
            }
        }
        let informationLi = this.state.informationLi || [];
        let fileId = '';
        for (var i = 0; i < informationLi.length; i++) {
            fileId = fileId + informationLi[i].id + ',';
        }
        createObj.fileId = fileId.substr(0, fileId.length - 1);
        if (existUnFaYun == 1) {
            confirm({
                content: '存在未发运数量，是否继续？',
                onOk() {
                    if (createObj.productList.length < 1) {
                        openNotice('error', '请添加商品', '');
                        self.setState({usable: false});
                    } else {
                        if (x == 1) {
                            openNotice('error', '请确认数量', '');
                            self.setState({usable: false});
                        } else {
                            createForSave(createObj).then(result => {
                                if (result.status && result.code == 200) {
                                    // openNotice('success', '创建成功', '');
                                    // self.goView('order');
                                    openNotice('success', '保存成功', '');
                                    self.setState({getProCode: result.data.getProCode});
                                    self.setState({sourceNo: result.data.sourceNo});
                                    self.setState({orderSubmit4: 'block'});
                                    self.goView(`order/addProject1/${9}&${result.data.id}`);
                                    self.setState({
                                        usable: false,
                                        teJiaShow: false,
                                        shouHuoShow: false,
                                        xinzengShow1: true,
                                        xinzengShow: true
                                    });
                                } else {
                                    openNotice('error', '创建失败', result.message || '');
                                    self.setState({usable: false});
                                }
                            });
                        }
                    }
                },
                onCancel() {
                    self.setState({usable: false});
                    return
                },
            });
        } else {
            if (createObj.productList.length < 1) {
                openNotice('error', '请添加商品', '');
                self.setState({usable: false});
            } else {
                if (x == 1) {
                    openNotice('error', '请确认数量', '');
                    self.setState({usable: false});
                } else {
                    createForSave(createObj).then(result => {
                        if (result.status && result.code == 200) {
                            openNotice('success', '保存成功', '');
                            self.setState({getProCode: result.data.getProCode});
                            self.setState({sourceNo: result.data.sourceNo});
                            self.setState({orderSubmit4: 'block'});
                            self.goView(`order/addProject1/${9}&${result.data.id}`);
                            self.setState({
                                usable: false,
                                teJiaShow: false,
                                shouHuoShow: false,
                                xinzengShow1: true,
                                xinzengShow: true
                            });
                        } else {
                            openNotice('error', '创建失败', result.message || '');
                            self.setState({usable: false});
                        }
                    });
                }
            }
        }
    };


    addPageChange3 = (page, pageSize) => {
        this.setState({addRows3: []});
        this.setState({addSearchObj3: {...this.state.addSearchObj3, s: pageSize, p: page}}, function () {
            this.getAddArray3();
        });
    };

    /*选择物料-物料名称搜索*/
    guiShuChange1 = (event) => {
        this.setState({
            specCode: event.target.value
        });
    };
    guiShuChange10 = (event) => {
        this.setState({
            contractOrderCode: event.target.value
        });
    };
    guiShuChange2 = (event) => {
        this.setState({
            projectName: event.target.value
        });
    };
    guiShuChange20 = (event) => {
        this.setState({
            contractOrderName2: event.target.value
        });
    };

    guiShuChange5 = (event) => {
        this.setState({
            projectName: event.target.value
        });
    };
    getAddArray3 = () => {
        //李 新增
        //分页查询在只有将页码赋值到第一页才能在当前页查询不同页码内的数据
        if (this.state.specCode != this.state.lastsearch) {
            this.state.addSearchObj3.p = 1;
            this.state.lastsearch = this.state.specCode;
        }
        getPro4({
            projectName: this.state.projectName,
            specCode: this.state.specCode,
            productType: this.state.addSearchObj3.proDetailType,
            cusCode: this.state.detailData.cusCode,
            buyCompanyId: this.state.purchaseId,
            channelCode: this.state.orderData.channelCode,
            p: this.state.addSearchObj3.p,
            s: this.state.addSearchObj3.s
        }).then(result => {
            if (result.status && result.code == 200) {
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows3: data,
                    addTotal3: result.total,
                });
            } else {
                message.error(result.message);
            }
        })
    };
    getAddArray5 = () => {
        getPro6({
            purchaseId: this.state.purchaseId,
            channelCode: this.state.orderData.channelCode,
            p: this.state.addSearchObj5.p,
            s: this.state.addSearchObj5.s,
            contractOrderName: this.state.contractOrderName2 || '',
            contractOrderCode: this.state.contractOrderCode || ''
        }).then(result => {
            if (result.status && result.code == 200) {
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows5: data,
                    addTotal5: result.total,
                });
            } else {
                message.error(result.message);
            }
        })

    }

    /*获取数据*/
    initData() {
        var orderListData = this.state.orderListData;
        var orderData = this.state.orderData;
        this.setState({
            loading: true
        })
        /*获取详情数据*/
        const self = this;
        var purchaseId = this.state.purchaseId;
        var thirdId = this.state.orderData.thirdId;
        getDetail(purchaseId, thirdId).then(res => {
            var x = res.data;
            var timestamp = new Date().getTime();
            x.createdDate = timestamp;
            self.setState({
                detailData: x,
                decimalPlace: res.data.decimalPlace || '',
                optionAddress: res.data.addressList || '',
                optionTerminal: res.data.terminalList || '',
                terminalOrderFlag: res.data.terminalOrderFlag || '',
                loading: false
            }, () => {
                console.log('params' + this.props.params.id);
                if (res.data.addressList.length == 1 && this.props.params.id != 6) {
                    this.setState({
                        gatherRealityAddress2: res.data.addressList[0].id + '',
                        gatherRealityAddress: res.data.addressList[0].detailAddress,
                        recipientName: res.data.addressList[0].recipientName,
                        mobile: res.data.addressList[0].mobile,
                        receiveAddressId: res.data.addressList[0].id,
                        deliveryShowprice: res.data.addressList[0].deliveryShowPrice || 'Y',
                        xinzengShow: false,
                        xinzengShow1: false,
                        loading: false
                    });
                }
            });
            if (x.reserveHid != null) {
                self.setState({id6: true});
            }
        })
        getTiAddress(orderData.cusName, purchaseId).then(res => {
            self.setState({
                tiAddress: res.data || '',
            }, () => {
                if (res.data.length == 1 && this.props.params.id != 4) {
                    self.setState({
                        defaultAddress: res.data[0].delvName,
                        usable: true,
                        orgId: res.data[0].id,
                        orgName: res.data[0].delvName
                    });
                }
            });
        })
    }

    /*实际收货地址选中*/
    addressChange = (value) => {
        const self = this;
        let address = this.state.optionAddress.filter(x => x.id == value)[0];
        var recipientName = address.recipientName;
        var receiveAddressId = address.id;
        var mobile = address.mobile;
        var detailAddress = address.detailAddress;
        var deliveryShowPrice = address.deliveryShowPrice;
        var submitRows = [...this.state.submitRows];
        self.setState({
            usable: true,
            receiveAddressId: receiveAddressId
        }, () => {
            this.refreshList();
        });

        self.setState({
            gatherRealityAddress2: value,
            gatherRealityAddress: detailAddress || '',
            recipientName: recipientName,
            mobile: mobile,
            receiveAddressId: receiveAddressId,
            xinzengShow: false,
            shouHuoShow: false,
            deliveryShowprice: deliveryShowPrice || 'Y'
        }, () => {
            if (self.state.teJiaShow == true && self.state.shouHuoShow == false) {
                self.setState({xinzengShow: false, xinzengShow1: false}, () => {
                    if (self.props.params.id == 6) {
                        self.setState({xinzengShow1: true})
                    }
                });
                for (let i = 0; i < self.state.submitRows.length; i++) {
                    giveTeJia({
                        customerId: parseInt(self.state.orderData.thirdId),
                        proId: self.state.submitRows[i].productId,
                        purchaseId: self.state.detailData.id,
                        channelCode: self.state.orderData.channelCode,
                        flowCode: self.state.guiShu1,
                    }).then(result => {
                        var submitRows = [...this.state.submitRows];
                        submitRows[i].terminalPriceRate = result.data.terminalPriceRate;
                        submitRows[i].terminalPriceRate1 = result.data.terminalPriceRate;
                        submitRows[i].terminalUnitPrice = result.data.terminalUnitPrice;
                        submitRows[i].terminalUnitPrice1 = result.data.terminalUnitPrice;
                        submitRows[i].offerLineId = result.data.offerLineId;
                        if (result.data.terminalPriceRate == '' && result.data.terminalUnitPrice == '') {
                            submitRows[i].specialFlag = 0;
                        } else {
                            submitRows[i].specialFlag = 1;
                        }
                        if (result.data.quantity != null) {
                            submitRows[i].quantity = result.data.quantity;
                            submitRows[i].countMax = result.data.quantity;
                        }
                    }, () => {
                        self.setState({submitRows});
                    })
                }
            }
        });

    };
    projectChange = (value) => {
        this.setState({
            projectCooperation: value || '',
        });
    };

    deliveryShowpriceChange = (value) => {
        this.setState({
            deliveryShowprice: value || '',
        });
    };

    wholeDeliveryChange = (value) => {
        this.setState({
            wholeDelivery: value || '',
        });
    };

    addressChange2 = (value, option) => {
        var self = this;
        var index = option.props.recordIndex;
        this.setState({
            ...this.state,
            submitRows: this.state.submitRows.map((x, index) => {
                if (index == option.props.recordIndex) {
                    return {
                        ...x,
                        pickProAddress: value
                    }
                } else {
                    return x
                }
            })
        })
        let list = this.state.tiAddress;
        let messagess = {};
        for (let i = 0; i < list.length; i++) {
            if (list[i].id === parseInt(value)) {
                messagess = list[i];
                break;
            }
        }
        var submitRows = self.state.submitRows;
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        submitRows[index].pickProAddress = messagess.delvName + '';
        submitRows[index].delvId = parseInt(value);
        submitRows[index].pickProAddressId = parseInt(value);
        self.setState({submitRows: submitRows});
        var postList = {
            channelCode: self.state.orderData.channelCode,
            customerId: parseInt(self.state.orderData.thirdId),
            proId: self.state.submitRows[index].productId,
            purchaseId: self.state.detailData.id,
            pickProAddress: messagess.delvName,
            pickProAddressId: messagess.id,
            count: self.state.submitRows[index].count || 0,
            receiveAddressId: self.state.receiveAddressId,
        };
        postCount++;
        getDongList(postList).then(res => {
            if (res.code == 200 && res.data) {
                finishCount++;
                if (postCount == finishCount) {
                    self.setState({
                        usable: false,
                    });
                }
                var day = self.state.day;
                var productionCycle = self.state.productionCycle;
                var date = self.state.date;
                var xiaFuJia = self.state.xiaFuJia;
                var weiFaYunCount = self.state.weiFaYunCount;
                var gfjyzr = self.state.gfjyzr;
                var jcxf = self.state.jcxf;
                var tehzr = self.state.tehzr;
                var tehzr2 = self.state.tehzr2;
                var tgzr = self.state.tgzr;
                var tihzr = self.state.tihzr;
                var tpzr = self.state.tpzr;
                var xfxzr = self.state.xfxzr;
                var xszr = self.state.xszr;
                var zzzr = self.state.zzzr;
                var onhand = self.state.onhand;
                var cadreRepertory = self.state.cadreRepertory;
                var defDeliverDay = self.state.defDeliverDay;
                var productName = self.state.productName;
                var reserveLineId = self.state.reserveLineId;
                var reserveQuantity = self.state.reserveQuantity;

                day[index] = res.data.day || 0;
                productionCycle[index] = res.data.productionCycle || 0;
                date[index] = res.data.date || 0;
                xiaFuJia[index] = res.data.xiaFuJia || 0;
                weiFaYunCount[index] = res.data.weiFaYunCount || 0;
                gfjyzr[index] = res.data.gfjyzr || 0;
                jcxf[index] = res.data.jcxf || 0;
                tehzr[index] = res.data.tehzr || 0;
                tehzr2[index] = res.data.tehzr2 || 0;
                tgzr[index] = res.data.tgzr || 0;
                tihzr[index] = res.data.tihzr || 0;
                tpzr[index] = res.data.tpzr || 0;
                xfxzr[index] = res.data.xfxzr || 0;
                xszr[index] = res.data.xszr || 0;
                zzzr[index] = res.data.zzzr || 0;
                onhand[index] = res.data.onhand;
                cadreRepertory[index] = res.data.cadreRepertory;
                defDeliverDay[index] = res.data.defDeliverDay;
                productName[index] = res.data.productName;
                reserveLineId[index] = res.data.reserveLineId;
                reserveQuantity[index] = res.data.reserveQuantity;

                /*if (res.data.date == '待评审') {
                    submitRows[index].deliveryArrivalDate = null;
                } else {
                    submitRows[index].deliveryArrivalDate = submitRows[index].deliveryArrivalDate && submitRows[index].capacityControl == 1 ? submitRows[index].deliveryArrivalDate : res.data.date;
                }*/
                submitRows[index].xiaFuJia = res.data.xiaFuJia;
                submitRows[index].onhand = res.data.onhand;
                submitRows[index].cadreRepertory = res.data.cadreRepertory;
                submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                submitRows[index].productionCycle = res.data.productionCycle;
                submitRows[index].day = res.data.day;
                submitRows[index].date = res.data.date;
                submitRows[index].showPrice = res.data.listPrice;
                if (submitRows[index].reserveLid == null || submitRows[index].reserveLid == "") {
                    if (res.data.reserveLineId != "") {
                        if (res.data.reserveQuantity < submitRows[index].count) {
                            submitRows[index].reserveLid = null;
                        } else {
                            submitRows[index].reserveLid = res.data.reserveLineId;
                        }
                    }
                }
                self.setState({
                    day: day,
                    productionCycle: productionCycle,
                    date: date,
                    xiaFuJia: xiaFuJia,
                    weiFaYunCount: weiFaYunCount,
                    gfjyzr: gfjyzr,
                    jcxf: jcxf,
                    tehzr: tehzr,
                    tehzr2: tehzr2,
                    tgzr: tgzr,
                    tihzr: tihzr,
                    tpzr: tpzr,
                    xfxzr: xfxzr,
                    xszr: xszr,
                    zzzr: zzzr,
                    onhand: onhand,
                    cadreRepertory: cadreRepertory,
                    defDeliverDay: defDeliverDay,
                    productName: productName,
                    submitRows: submitRows,
                    reserveLineId: reserveLineId,
                    reserveQuantity: reserveQuantity
                }, () => {
                    self.price();
                })
            } else {
                openNotice('warning', '数据获取失败，请确认特价单号、实际收货地址、提货地点、开单数量是否正确');
            }
        })


    };
    onSelectChange3 = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys3: selectedRowKeys,
        })
    };
    onSelectChange5 = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys5: selectedRowKeys,
            selectedRows5: selectedRows[0].kyAmount
        })
    };

    /*项目信息（含终端）选中*/
    terminalChange = (value) => {
        var seller = this.state.optionTerminal[value.key].seller;
        this.setState({
            projectMessage: value.label,
            seller: seller
        });
    };
    /*备注信息填写*/
    remarkChange = (event) => {
        this.setState({
            remark: event.target.value
        });
    };
    remarkChange1 = (event) => {
        this.setState({
            remark11: event.target.value
        });
    };
    remarkChange2 = (event) => {
        this.setState({
            remark22: event.target.value
        });
    };
    remarkChange3 = (event) => {
        this.setState({
            remark33: event.target.value
        });
    }
    remarkChange4 = (event) => {
        this.setState({
            remark44: event.target.value
        });
    }
    pullmanNameChange = (event) => {
        this.setState({
            pullmanName: event.target.value
        });
    }

    deliveryTimeonChange = (index, value) => {
        var submitRows = this.state.submitRows;
        submitRows[index].deliveryArrivalDate = value;
        console.log(submitRows);
        this.setState({
            submitRows: submitRows
        });
    };

    changeRemark = (record, index, value) => {
        if (value.target.value.length > 100) {
            return
        }
        var submitRows = this.state.submitRows;
        submitRows[index].remark = value.target.value;
        this.setState({
            submitRows: submitRows
        });
    }
    changeRemark1 = (record, value, index) => {
        var self = this;
        if (typeof index == 'string') {
            return
        }
        var submitRows = this.state.submitRows;
        submitRows[value].terminalPriceRate = index;
        submitRows[value].terminalUnitPrice = (submitRows[value].showPrice * (1 - index / 100)).toFixed(6);
        if (index == undefined) {
            submitRows[value].terminalPriceRate = 0;
            submitRows[value].terminalUnitPrice = 0;
        }
        this.setState({
            submitRows: submitRows
        }, () => {
            self.price();
        });
    }
    changeRemark2 = (record, value, index) => {
        var submitRows = this.state.submitRows;
        if (typeof index == 'string') {
            return
        }
        submitRows[value].terminalUnitPrice = index;
        submitRows[value].terminalPriceRate = ((1 - index / submitRows[value].showPrice) * 100).toFixed(6);
        if (index == undefined) {
            submitRows[value].terminalPriceRate = 0;
            submitRows[value].terminalUnitPrice = 0;
        }
        this.setState({
            submitRows: submitRows
        }, () => {
            this.price()
        });
    }

    /*拉动渠道选中*/
    pullChannelChange = (value) => {
        this.setState({
            pullChannel: value,
        });
    }
    onChangeInputNumber = (record, index, value) => {
        const self = this;
        var submitRows = this.state.submitRows;
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        if (value == "") {
            submitRows[index].count = 0;
        } else if (typeof value == 'string') {
            return
        }
        if (!record.pickProAddress) {
            openNotice('warning', '请选择提货地点');
            submitRows[index].count = 0;
        } else {
            if (self.state.submitRows[index].countMax != null && value > self.state.submitRows[index].countMax) {
                openNotice('warning', '该行产品累计开单数量已超过特价申请，特价剩余数量为' + self.state.submitRows[index].countMax);
                submitRows[index].count = submitRows[index].countMax;
            } else {
                submitRows[index].count = value;
            }
            var a = record.id - 1;
            var postList = {
                channelCode: self.state.orderData.channelCode,
                customerId: parseInt(self.state.orderData.thirdId),
                purchaseId: self.state.detailData.id,
                pickProAddress: self.state.submitRows[index].pickProAddress,
                pickProAddressId: self.state.submitRows[index].delvId,
                proId: self.state.submitRows[index].productId,
                count: self.state.submitRows[index].count || 0,
                receiveAddressId: self.state.receiveAddressId,
            };
            // console.log(postList)
            postCount++;
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        self.setState({
                            usable: false,
                        });
                    }
                    var day = self.state.day;
                    var productionCycle = self.state.productionCycle;
                    var date = self.state.date;
                    var xiaFuJia = self.state.xiaFuJia;
                    var weiFaYunCount = self.state.weiFaYunCount;
                    var gfjyzr = self.state.gfjyzr;
                    var jcxf = self.state.jcxf;
                    var tehzr = self.state.tehzr;
                    var tehzr2 = self.state.tehzr2;
                    var tgzr = self.state.tgzr;
                    var tihzr = self.state.tihzr;
                    var tpzr = self.state.tpzr;
                    var xfxzr = self.state.xfxzr;
                    var xszr = self.state.xszr;
                    var zzzr = self.state.zzzr;
                    var onhand = self.state.onhand;
                    var cadreRepertory = self.state.cadreRepertory;
                    var defDeliverDay = self.state.defDeliverDay;
                    var productName = self.state.productName;
                    var reserveLineId = self.state.reserveLineId;
                    var reserveQuantity = self.state.reserveQuantity;
                    day[index] = res.data.day;
                    date[index] = res.data.date;
                    xiaFuJia[index] = res.data.xiaFuJia;
                    weiFaYunCount[index] = res.data.weiFaYunCount;
                    productionCycle[index] = res.data.productionCycle;
                    gfjyzr[index] = res.data.gfjyzr;
                    jcxf[index] = res.data.jcxf;
                    tehzr[index] = res.data.tehzr;
                    tehzr2[index] = res.data.tehzr2;
                    tgzr[index] = res.data.tgzr;
                    tihzr[index] = res.data.tihzr;
                    tpzr[index] = res.data.tpzr;
                    xfxzr[index] = res.data.xfxzr;
                    xszr[index] = res.data.xszr;
                    zzzr[index] = res.data.zzzr;
                    onhand[index] = res.data.onhand;
                    cadreRepertory[index] = res.data.cadreRepertory;
                    defDeliverDay[index] = res.data.defDeliverDay;
                    productName[index] = res.data.productName;
                    reserveLineId[index] = res.data.reserveLineId;
                    reserveQuantity[index] = res.data.reserveQuantity;

                    /*if (res.data.date == '待评审') {
                        submitRows[index].deliveryArrivalDate = null;
                    } else {
                        submitRows[index].deliveryArrivalDate = submitRows[index].deliveryArrivalDate && submitRows[index].capacityControl == 1 ? submitRows[index].deliveryArrivalDate : res.data.date;
                    }*/
                    submitRows[index].xiaFuJia = res.data.xiaFuJia;
                    submitRows[index].onhand = res.data.onhand;
                    submitRows[index].cadreRepertory = res.data.cadreRepertory;
                    submitRows[index].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[index].productionCycle = res.data.productionCycle;
                    submitRows[index].day = res.data.day;
                    submitRows[index].date = res.data.date;
                    submitRows[index].showPrice = res.data.listPrice;
                    if (submitRows[index].reserveLid == null || submitRows[index].reserveLid == "") {
                        if (res.data.reserveLineId != "") {
                            if (res.data.reserveQuantity < submitRows[index].count) {
                                submitRows[index].reserveLid = null;
                            } else {
                                submitRows[index].reserveLid = res.data.reserveLineId;
                            }
                        }
                    }
                    self.setState({
                        day: day,
                        productionCycle: productionCycle,
                        date: date,
                        onhand: onhand,
                        cadreRepertory: cadreRepertory,
                        xiaFuJia: xiaFuJia,
                        weiFaYunCount: weiFaYunCount,
                        gfjyzr: gfjyzr,
                        jcxf: jcxf,
                        tehzr: tehzr,
                        tehzr2: tehzr2,
                        tgzr: tgzr,
                        tihzr: tihzr,
                        tpzr: tpzr,
                        xfxzr: xfxzr,
                        xszr: xszr,
                        zzzr: zzzr,
                        defDeliverDay: defDeliverDay,
                        productName: productName,
                        reserveLineId: reserveLineId,
                        reserveQuantity: reserveQuantity,
                        submitRows: submitRows
                    }, () => {
                        this.price();
                    })
                } else {
                    openNotice('warning', '数据获取失败，请确认特价单号、实际收货地址、提货地点、开单数量是否正确');
                }
            })
        }
    };

    price() {
        var self = this;
        var price = 0;
        var allPrice = 0;
        var realyPrice = 0;
        var cutPrice = 0;
        var allRealyPrice = 0;
        var everyPrice = 0;
        var everyRealyPrice = 0;
        var everyCount = 0;
        for (var i = 0; i < self.state.submitRows.length; i++) {
            everyCount = self.state.submitRows[i].count || 0;
            everyPrice = self.state.submitRows[i].showPrice || 0;
            everyRealyPrice = self.state.submitRows[i].terminalUnitPrice || 0;
            allPrice = everyCount * everyPrice;
            price = price + allPrice;
            allRealyPrice = everyCount * everyRealyPrice;
            realyPrice = realyPrice + allRealyPrice;
            cutPrice = price - realyPrice;
        }

        var priceOfAll = price.toFixed(2);
        var priceOfRealy = realyPrice.toFixed(2);
        var priceOfCut = cutPrice.toFixed(2);
        self.setState({allPrice: priceOfAll, realyPrice: priceOfRealy, cutPrice: priceOfCut});
    }


    //离开当前路由时，更新store
    routeLeaveHook = (nextLocation) => {
    };

    componentWillMount() {
        const self = this;
        Notification.config({
            placement: 'topRight',
            top: 100,
            duration: 1,
        });
        window.myTemp = 1;
        var src = window.localStorage.getItem('server');
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            passId: JSON.parse(localStorage.getItem('passId')),
            src: src
        });
        if (self.props.params.id == 4) {
            var orderListData = this.state.orderListData;
            var submitRows = orderListData.map(x => ({
                itemNum: x.productCode || x.itemNum || '',
                count: x.count || '',
                proLine: x.proLine || '',
                productionCycle: x.productionCycle || '',
                pickProAddress: self.state.tiAddress2 || '',
                productName: x.name || '',
                productId: x.productId || '',
                showPrice: x.price || x.showPrice || '',
                remark: x.remark || '',
                stockType: x.stockType || '',
                unit: x.unit || '',
                packageQuantity: x.packageQuantity || '',
                minPackageQuantity: x.minPackageQuantity || '',
                shoppingcartId: x.id || '',
                countMax: x.countMax || null,
                specialFlag: x.specialFlag || null,
                deliveryArrivalDate: x.deliveryArrivalDate || '',
                factory: x.factory || '',
                capacityControl: x.capacityControl || '',
                id: window.myTemp++
            }));
            self.setState({submitRows})
        }

        if (self.props.params.id == 5) {
            var dingPassParse = this.state.dingPassParse;
            var submitRows = [...self.state.submitRows];
            for (var i = 0; i < dingPassParse.length; i++) {
                var x = {
                    itemNum: dingPassParse[i].erpData.ITEM_NUM || '',
                    count: dingPassParse[i].count || '',
                    proLine: dingPassParse[i].proLine || '',
                    productionCycle: dingPassParse[i].productionCycle || '',
                    pickProAddress: self.state.tiAddress2 || '',
                    productName: dingPassParse[i].erpData.ITEM_DESC || '',
                    productId: dingPassParse[i].productId || '',
                    showPrice: dingPassParse[i].erpData.PRICE || '',
                    stockType: dingPassParse[i].stockType || '',
                    unit: dingPassParse[i].unit || '',
                    packageQuantity: dingPassParse[i].packageQuantity || '',
                    minPackageQuantity: dingPassParse[i].minPackageQuantity || '',
                    bookId: dingPassParse[i].bookId || '',
                    countMax: dingPassParse[i].countMax || null,
                    specialFlag: dingPassParse[i].specialFlag || null,
                    deliveryArrivalDate: dingPassParse[i].deliveryArrivalDate || '',
                    factory: dingPassParse[i].factory || '',
                    capacityControl: dingPassParse[i].capacityControl || '',
                    id: window.myTemp++,
                }
                submitRows.push(x);
            }
            self.setState({submitRows})
        }
        if (self.props.params.id == 6) {
            var passParse = this.state.passParse;
            var submitRows = [...self.state.submitRows];
            var orderData = {...self.state.orderData};
            var detailData = {...self.state.detailData};
            for (var i = 0; i < passParse.length; i++) {
                var x = {
                    itemNum: passParse[i].proCode || '',
                    count: passParse[i].commitQuantity2 || '',
                    proLine: passParse[i].proLine || '',
                    reserveLid: passParse[i].lineId || '',
                    productionCycle: passParse[i].productionCycle || '',
                    pickProAddress: passParse[i].orgName || '',
                    pickProAddressId: passParse[i].orgId || '',
                    delvId: passParse[i].orgId || '',
                    productName: passParse[i].proDesc || '',
                    productId: passParse[i].productId || '',
                    showPrice: passParse[i].showPrice || '',
                    terminalUnitPrice: passParse[i].requestPrice || '',
                    remark: passParse[i].remark || '',
                    stockType: passParse[i].stockType || '',
                    unit: passParse[i].unit || '',
                    packageQuantity: passParse[i].packageQuantity || '',
                    minPackageQuantity: passParse[i].minPackageQuantity || '',
                    countMax: passParse[i].countMax || null,
                    specialFlag: passParse[i].specialFlag || null,
                    deliveryArrivalDate: passParse[i].deliveryArrivalDate || '',
                    factory: passParse[i].factory || '',
                    capacityControl: passParse[i].capacityControl || '',
                    id: window.myTemp++,
                }
                x.terminalPriceRate = ((1 - x.terminalUnitPrice / x.showPrice) * 100).toFixed(6);
                submitRows.push(x);
            }
            self.setState({submitRows});
            orderData.PurchaseUnit = passParse[0].buyCompanyName;
            orderData.channel = passParse[0].channel;
            orderData.thirdId = parseInt(passParse[0].cusId);
            orderData.channelCode = passParse[0].channelCode;
            orderData.cusId = parseInt(passParse[0].cusId);
            orderData.cusName = parseInt(passParse[0].cusId);
            detailData.createdDate = passParse[0].createdDate;
            detailData.cusName = passParse[0].customerName;
            detailData.status = passParse[0].status;
            detailData.id = parseInt(passParse[0].buyCompanyId);
            detailData.customerName = passParse[0].customerName;
            detailData.cusCode = passParse[0].customerCode;
            getGdList({
                customerId: parseInt(passParse[0].cusId),
                channelCode: passParse[0].channelCode,
                p: 1,
                s: 10,
                purchaseId: passParse[0].buyCompanyId
            }).then(result => {
                if (result.data.length > 0 && result.status == true) {
                    orderData.defDiscount = result.data[0].defDiscount || 0;
                    orderData.sxeAmount = result.data[0].sxeAmount || 0;
                    orderData.pay = result.data[0].pay || 0;
                } else {
                    message.error(result.message);
                }
            });
            self.setState({
                orderData,
                detailData,
                purchaseId: passParse[0].buyCompanyId,
                channelCode: passParse[0].channelCode,
                reserveHid: passParse[0].headerId,
                id6: true,
                remark: '预订单编号:' + passParse[0].headerId,
            });
        }
        /*从编辑进入详情*/
        if (self.props.params.id == 9) {
            var orderData = {...self.state.orderData};
            var detailData = {...self.state.detailData};
            /*获取订单详情*/
            getOrderDetails({id: self.props.params.orderId}).then(function (result) {
                if (result && result.code == 200) {
                    var passParse = result.data.productList;
                    var passDetail = result.data;
                    orderData.PurchaseUnit = passDetail.buyCompany;
                    orderData.channel = passDetail.channel;
                    orderData.thirdId = parseInt(passDetail.cusId);
                    orderData.channelCode = passDetail.channelCode;
                    orderData.cusId = parseInt(passDetail.cusId);
                    orderData.cusName = parseInt(passDetail.cusId);
                    orderData.orderSource = passDetail.orderSource;
                    detailData.createdDate = passDetail.createdDate;
                    detailData.cusName = passDetail.customerName;
                    detailData.status = passDetail.status;
                    detailData.id = parseInt(passDetail.buyCompanyId);
                    detailData.customerName = passDetail.customerName;
                    detailData.cusCode = passDetail.customerCode;
                    orderData.defDiscount = passDetail.discountRate;
                    orderData.sxeAmount = passDetail.remainingSum;
                    orderData.sourceNo = passDetail.sourceNo;
                    orderData.businessChannel = passDetail.businessChannel;
                    //  orderData.escrowFlag = passDetail.escrowFlag;
                    orderData.escrowFlag = passDetail.selectEscrowFlag == 'Y' ? 1 : 0;
                    if (passDetail.orderSubmit == false) {
                        orderData.orders = 1;
                        self.setState({orderSubmit3: 'none', orderSubmit2: 'block'})
                    } else {
                        orderData.orders = 0;
                        self.setState({orderSubmit3: 'block', orderSubmit2: 'none'})
                    }
                    if (passDetail.orderStatus == 1 && passDetail.getProCode != null) {
                        self.setState({orderSubmit4: 'block'})
                    }
                    self.setState({
                        orderData,
                        detailData,
                        purchaseId: passDetail.buyCompanyId,
                        channelCode: passDetail.channelCode,
                        deliveryShowprice: passDetail.deliveryShowprice,
                        id6: passDetail.reserveHid ? true : false,
                        status: passDetail.erpStatus,
                        sourceNo: passDetail.sourceNo,
                        selectEscrowFlag: passDetail.selectEscrowFlag || 'N'
                    });
                    var submitRows = [...self.state.submitRows];
                    self.setState({
                        usable: true,
                    });

                    if (self.props.params.type != '再来一单') {
                        //编辑进去后刷新特价
                        if (passDetail.specialOfferCode != null && passDetail.specialOfferCode != "") {
                            self.setState({finishTeLoad: true});
                            const getTjList = [];
                            for (var i = 0; i < passParse.length; i++) {
                                getTjList.push({
                                    customerId: parseInt(orderData.thirdId),
                                    proId: passParse[i].productId,
                                    purchaseId: detailData.id,
                                    channelCode: orderData.channelCode,
                                    flowCode: passDetail.specialOfferCode,
                                });
                            }
                            giveTeJia2(getTjList).then(result => {
                                if (result.code == 200 && result.data) {
                                    var tjlist = result.data;
                                    submitRows.map(item => {
                                        tjlist.map(itm => {
                                            if (item.itemNum == itm.proCode) {
                                                item.terminalPriceRate = itm.terminalPriceRate;
                                                item.terminalPriceRate1 = itm.terminalPriceRate;
                                                item.terminalUnitPrice = itm.terminalUnitPrice;
                                                item.terminalUnitPrice1 = itm.terminalUnitPrice;

                                                item.offerLineId = itm.offerLineId;
                                                if (item.terminalPriceRate == '' && item.terminalUnitPrice == '') {
                                                    item.specialFlag = 0;
                                                } else {
                                                    item.specialFlag = 1;
                                                }
                                                if (itm.quantity != null) {
                                                    item.quantity = itm.quantity;
                                                    item.countMax = itm.quantity;
                                                    if (item.count > itm.quantity) {
                                                        item.count = itm.quantity;
                                                    }
                                                } else {
                                                    item.quantity = null;
                                                    item.countMax = null;
                                                }
                                            }
                                        })
                                    })
                                    self.setState({submitRows, finishTeLoad: false});
                                }
                            });
                        }

                        //编辑进去bpm导入的刷新预订单信息
                        if (passDetail.orderSource != null) {
                            for (var i = 0; i < passParse.length; i++) {
                                self.getreserve(passParse[i].productId, passParse[i].delvId);
                            }
                            getReserve(self.state.getReserveList).then(result => {
                                if (result.code == 200 && result.data) {
                                    self.setState({reserveList: result.data}, () => {
                                        self.tick2();
                                    });
                                }
                            });
                        }
                    }

                    for (let i = 0; i < passParse.length; i++) {
                        if (passParse[i].orderProductPartList) {
                            for (let j = 0; j < passParse[i].orderProductPartList.length; j++) {
                                passParse[i].orderProductPartList[j].appointDeliveryDate = moment(passParse[i].orderProductPartList[j].appointDeliveryDate)
                            }
                        }
                        //存在预订单不能修改提货地点
                        if (passParse[i].reserveLid != null) {
                            self.setState({reserveFlag: true});
                        }
                        var x = {
                            itemNum: passParse[i].productCode || '',
                            count: passParse[i].count || '',
                            proLine: passParse[i].proLine || '',
                            reserveLid: passParse[i].reserveLid || '',
                            productionCycle: passParse[i].productionCycle || '',
                            pickProAddress: passParse[i].pickProAddress || '',
                            pickProAddressId: parseInt(passParse[i].delvId) || '',
                            productName: passParse[i].productName || '',
                            productId: passParse[i].productId || '',
                            showPrice: passParse[i].originalPrice || '',
                            remark: passParse[i].remark || '',
                            stockType: passParse[i].stockType || '',
                            unit: passParse[i].unit || '',
                            packageQuantity: passParse[i].packageQuantity || '',
                            minPackageQuantity: passParse[i].minPackageQuantity || '',
                            terminalPriceRate: passParse[i].terminalPriceRate || '',
                            terminalUnitPrice: passParse[i].terminalUnitPrice || '',
                            offerLineId: passParse[i].offerLineId || '',
                            subinventory: passParse[i].subinventory || '',
                            delvId: passParse[i].delvId || '',
                            orderProductPartList: passParse[i].orderProductPartList || '',
                            id: window.myTemp++,
                            faYunCount: passParse[i].faYunCount || '',
                            weiFaYunCount: passParse[i].weiFaYunCount || '',
                            countMax: passParse[i].countMax || null,
                            specialFlag: passParse[i].specialFlag || null,
                            deliveryArrivalDate: passParse[i].deliveryArrivalDate || '',
                            factory: passParse[i].factory || '',
                            capacityControl: passParse[i].capacityControl || '',
                            secondStockType: passParse[i].secondStockType || '',
                            noshowOnhand: passParse[i].noshowOnhand || '',
                        }
                        submitRows.push(x);

                        self.setState({
                            submitRows: submitRows,
                            receiveAddressId: passDetail.gatherAddressId,
                            remark: passDetail.remark,
                            customerOrderCode: passDetail.customerOrderCode,
                            remark44: passDetail.salesmanName,
                            recipientName: passDetail.contacts,
                            mobile: passDetail.phone,
                            id: passDetail.id,
                            guaranteeQuality: passDetail.guaranteeQuality,
                            delvId: passParse[i].delvId,
                            gatherRealityAddress: passDetail.gatherRealityAddress.toString(),
                            gatherRealityAddress1: passDetail.gatherRealityAddress.toString(),
                            gatherRealityAddress2: passDetail.gatherAddressId.toString(),
                            projectId: passDetail.projectId,
                            allPrice: passDetail.amount,
                            createdBy: passDetail.createdBy,
                            realyPrice: passDetail.realityAmount,
                            cutPrice: (passDetail.amount - passDetail.realityAmount).toFixed(6),
                            remark11: passDetail.completeFactory,
                            remark22: passDetail.closeHomologous,
                            remark33: passDetail.projectAddMsg,
                            specCode1: passDetail.specialOfferCode,
                            projectCooperation: passDetail.projectCooperation,
                            contractOrderCode: passDetail.contractNum,
                            contractOrderName: passDetail.contractOrderName,
                            contractId: passDetail.contractId,
                            guiShu1: passDetail.specialOfferCode,
                            informationLi: passDetail.fileUrls,
                            getProCode: passDetail.getProCode || '',
                            giveBackStatus: passDetail.orderStatus || 0,
                            dlType: passDetail.dlType || '',
                            reserveHid: passDetail.reserveHid || '',
                            headerId2: passDetail.headerId || '',
                            businessChannel: passDetail.businessChannel,
                            pullChannel: passDetail.pullChannel,
                            pullmanName: passDetail.pullmanName,
                            apiFlag: passDetail.orderSource ? true : false
                        }, () => {
                            if (self.props.params.id == 9) {
                                var state = {...self.state};
                                if (self.props.params.type && self.props.params.type == '再来一单') {
                                    submitRows.map(item => {
                                        delete item.deliveryArrivalDate;
                                        delete item.reserveLid;
                                        delete item.offerLineId;
                                    })
                                    delete self.state.getProCode;
                                    delete self.state.guiShu1;
                                    delete self.state.specCode1;
                                    delete self.state.specialOfferCode;
                                    delete self.state.apiFlag;
                                    delete self.state.customerOrderCode;
                                    delete self.state.remark;
                                    delete self.state.orderData.orderSource;
                                    delete self.state.orderData.sourceNo;
                                    // delete self.state.orderData.escrowFlag;
                                    delete self.state.contractOrderCode;
                                    delete self.state.contractOrderName;
                                    delete self.state.contractId;
                                    delete self.state.receiveAddressId;
                                    delete self.state.gatherRealityAddress;
                                    delete self.state.gatherRealityAddress2;
                                    self.setState({state: state, submitRows: submitRows, sourceNo: null});
                                    getGdList({
                                        customerId: passDetail.cusId,
                                        channelCode: passDetail.channelCode,
                                        p: 1,
                                        s: 10,
                                        purchaseId: parseInt(passDetail.buyCompanyId),
                                    }).then(result => {
                                        if (result.status && result.data.length > 0) {
                                            self.state.orderData.defDiscount = result.data[0].defDiscount;
                                            self.state.orderData.sxeAmount = result.data[0].sxeAmount;
                                            self.setState({state: state, orderSource: null});
                                        } else {
                                            message.error(result.message);
                                        }
                                    });
                                }
                            }
                        })

                    }
                    self.setState({submitRows}, () => {
                        self.initData();
                        self.refreshList();
                    });
                }

            });

        }
    };

    componentDidMount() {
        const self = this;
        if (this.props.params.id != 9) {
            this.initData();
            self.setState({apiFlag: false});
        }
        if (self.state.orderData.orders == 1) {
            self.setState({orderSubmit3: 'none', orderSubmit2: 'block'})
        }
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }


    handleOk = (selectedRowKeys) => {
        this.setState({visible: false});
    }
    handleOk2 = () => {
        this.setState({modalVisible: false, dataSource2: [], dataSource3: ''});
    }
    handleCancel = () => {
        this.setState({visible: false});
    }
    handleCancel2 = () => {
        this.setState({modalVisible: false, dataSource2: [], dataSource3: ''});
    }
    handleCancel4 = () => {
        this.setState({visible3: false});
    }
    handleCancel5 = () => {
        this.setState({visible4: false});
    }
    addFenPi = () => {
        const {count2, dataSource2, number2} = this.state;
    }
    deleteFenPi = () => {
        const {count2, dataSource2, number2} = this.state;
    }
    handleChange = (index, value) => {
        var dataSource2 = [...this.state.dataSource2];
        dataSource2[index].appointDeliveryDate = value;
        this.setState({dataSource2: dataSource2});
    }

    onOkData = (text, record, value) => {
        console.log('onOk: ', value);
    }
    handleAdd2 = () => {
        const {count2, dataSource2, number2} = this.state;
        const newData2 = {
            key: count2,
            startCount: '',
            endCount: '',
            discountCategory: '',
            discount: '',
            removeFlag2: 0,
            number2: number2
        };
        this.setState({
            dataSource2: [...dataSource2, newData2],
            count2: count2 + 1,
            number2: number2 + 1
        });
    }
    onCellChange2 = (record, index, value) => {
        const self = this;
        const dataSource2 = [...this.state.dataSource2];
        dataSource2[index].deliveryCount = value.target.value;
        this.setState({dataSource2: dataSource2});
    }
    onDelete2 = (key) => {
        const self = this;
        const dataSource2 = [...this.state.dataSource2];
        dataSource2.splice(key, 1);
        for (var i = 0; i < dataSource2.length; i++) {
            if (dataSource2[i] == "" || typeof (dataSource2[i]) == "undefined") {
                dataSource2.splice(i, 1);
                i = i - 1;
            }
        }
        this.setState({dataSource2: dataSource2})
    }

    async gettejia(productId, specCode) {
        const result = await giveTeJia({
            customerId: parseInt(this.state.orderData.thirdId),
            proId: productId,
            purchaseId: this.state.detailData.id,
            channelCode: this.state.channelCode,
            flowCode: specCode,
        })
        return result;
    }

    gettejia2(productId, specCode) {
        const getTjList = [...this.state.getTjList];
        getTjList.push({
            customerId: parseInt(this.state.orderData.thirdId),
            proId: productId,
            purchaseId: this.state.detailData.id,
            channelCode: this.state.channelCode,
            flowCode: specCode,
        });
        this.setState({getTjList});
    }

    getreserve(proId, delvId) {
        const getReserveList = [...this.state.getReserveList];
        getReserveList.push({
            customerId: parseInt(this.state.orderData.thirdId),
            proId: proId,
            purchaseId: this.state.detailData.id,
            channelCode: this.state.channelCode,
            pickProAddressId: delvId
        });
        this.setState({getReserveList});
    }


    onSelectRadio3 = (record, selected, selectedRows) => {
        let businessLines = [];
        businessLines.push(record.cooperateBusiness);
        businessLines.push(record.zdBusiness);
        businessLines.push(record.projectBusiness);
        businessLines.push(record.finalBusiness);
        this.setState({
            guiShu1: record.specCode,
            remark44: record.userName,
            remark11: record.zdCompany || record.pcCust,
            pullmanName: record.pullName,
            pullChannel: record.pullChannelCode,
            specCode1: record.specCode,
            cooperateBusiness: record.cooperateBusiness,
            zdBusiness: record.zdBusiness,
            projectBusiness: record.projectBusiness,
            finalBusiness: record.finalBusiness,
            businessLines: businessLines
        })
        //李 新增
        //分页查询在只有将页码赋值到第一页才能在当前页查询不同页码内的数据
        if (record.specCode != this.state.lastsearch) {
            this.state.addSearchObj4.p = 1;
            this.state.lastsearch = record.specCode;
        }
        getPro5({
            specCode: record.specCode,
            p: this.state.addSearchObj4.p,
            s: this.state.addSearchObj4.s
        }).then(result => {
            if (result.status && result.code == 200) {
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    specCode1: record.specCode,
                    addRows4: data,
                    addTotal4: result.total,
                });
            } else {
                message.error(result.message);
            }
        })

        var submitRows = [...this.state.submitRows];

        const getTjList = [];
        for (var i = 0; i < submitRows.length; i++) {
            getTjList.push({
                customerId: parseInt(this.state.orderData.thirdId),
                proId: submitRows[i].productId,
                purchaseId: this.state.detailData.id,
                channelCode: this.state.channelCode,
                flowCode: record.specCode,
            });
        }

        if (getTjList.length > 0) {
            giveTeJia2(getTjList).then(result => {
                if (result.code == 200 && result.data) {
                    var tjlist = result.data;
                    submitRows.map(item => {
                        tjlist.map(itm => {
                            if (item.itemNum == itm.proCode) {
                                item.terminalPriceRate = itm.terminalPriceRate;
                                item.terminalPriceRate1 = itm.terminalPriceRate;
                                item.terminalUnitPrice = itm.terminalUnitPrice;
                                item.terminalUnitPrice1 = itm.terminalUnitPrice;

                                item.offerLineId = itm.offerLineId;
                                if (item.terminalPriceRate == '' && item.terminalUnitPrice == '') {
                                    item.specialFlag = 0;
                                } else {
                                    item.specialFlag = 1;
                                }
                                if (itm.quantity != null) {
                                    item.quantity = itm.quantity;
                                    item.countMax = itm.quantity;
                                    if (item.count > itm.quantity) {
                                        item.count = itm.quantity;
                                    }
                                } else {
                                    item.quantity = null;
                                    item.countMax = null;
                                }
                            }
                        })
                    })
                    this.setState({submitRows});
                }
            });
        }
    }

    tick2 = () => {
        clearInterval(this.interval);
        var submitRows = [...this.state.submitRows];
        var reserveList = [...this.state.reserveList];
        submitRows.map(item => {
            if (item.reserveLid == null || item.reserveLid == "") {
                reserveList.map(itm => {
                    if (item.productId == itm.proId) {
                        if (item.count > itm.reserveQuantity) {
                            item.reserveLid = null;
                        } else {
                            item.reserveLid = itm.reserveLineId;
                        }
                    }
                })
            }
        })
        this.setState({...this.state.submitRows, submitRows});
    }

    tick3 = () => {
        clearInterval(this.interval);
        var submitRows = [...this.state.submitRows];
        var tjlist = [...this.state.tjlist];
        submitRows.map(item => {
            tjlist.map(itm => {
                if (item.itemNum == itm.proCode) {
                    if (item.terminalUnitPrice == '') {
                        item.terminalPriceRate = itm.terminalPriceRate;
                        item.terminalPriceRate1 = itm.terminalPriceRate;
                        item.terminalUnitPrice = itm.terminalUnitPrice;
                        item.terminalUnitPrice1 = itm.terminalUnitPrice;
                    }

                    item.offerLineId = itm.offerLineId;
                    if (item.terminalPriceRate == '' && item.terminalUnitPrice == '') {
                        item.specialFlag = 0;
                    } else {
                        item.specialFlag = 1;
                    }
                    if (itm.quantity != null) {
                        item.quantity = itm.quantity;
                        item.countMax = itm.quantity;
                        if (item.count > itm.quantity) {
                            item.count = itm.quantity;
                        }
                    } else {
                        item.quantity = null;
                        item.countMax = null;
                    }
                }
            })
        })
        this.setState({...this.state.submitRows, submitRows});
    }


    saveFenPi = (record, index, value) => {
        var submitRows = [...this.state.submitRows];
        var dataSource2 = [...this.state.dataSource2];
        var dataSource3 = parseInt(this.state.dataSource3);
        submitRows[dataSource3].orderProductPartList = dataSource2
        for (var i = 0; i < this.state.submitRows.length; i++) {
            if (this.state.submitRows[i].orderProductPartList && this.state.submitRows[i].orderProductPartList.length > 0) {
                for (let j = 0; j < this.state.submitRows[i].orderProductPartList.length; j++) {
                    this.state.submitRows[i].orderProductPartList[j].logisticsCycle = this.state.defDeliverDay[i];
                    this.state.submitRows[i].orderProductPartList[j].productName = this.state.productName2[i];
                    delete this.state.submitRows[i].orderProductPartList[j].key;
                    delete this.state.submitRows[i].orderProductPartList[j].startCount;
                    delete this.state.submitRows[i].orderProductPartList[j].endCount;
                    delete this.state.submitRows[i].orderProductPartList[j].discountCategory;
                    delete this.state.submitRows[i].orderProductPartList[j].discount;
                    delete this.state.submitRows[i].orderProductPartList[j].removeFlag2;
                    delete this.state.submitRows[i].orderProductPartList[j].number2;
                }
            }
        }
        var x = 0;
        var y = 0;
        var date = new Date();
        var date2 = new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000);
        for (var k = 0; k < dataSource2.length; k++) {
            x = x + parseInt(dataSource2[k].deliveryCount);
            if (!dataSource2[k].appointDeliveryDate || dataSource2[k].appointDeliveryDate < date || dataSource2[k].appointDeliveryDate > date2) {
                y = 1
            }
        }
        submitRows[dataSource3].faYunCount = x;

        if (x != submitRows[dataSource3].count) {
            openNotice('warning', '请确认发货数量');
        } else if (y == 1) {
            openNotice('warning', '请确认发货日期');
        } else {
            this.setState({submitRows: submitRows});
            this.setState({dataSource2: []});
            this.setState({modalVisible: false});
        }
    }
    openCity2 = () => {
        const self = this;
        if (self.state.guiShu1) {
            confirm({
                content: '选择特价将重置已选择的商品信息,确定吗?',
                onOk() {
                    self.setState({
                        visible3: true,
                    })
                    self.getAddArray3();
                },
                onCancel() {
                    return
                }
            })
        } else {
            self.setState({visible3: true});
            self.getAddArray3();
        }
    }
    openCity3 = () => {
        this.setState({visible4: true})
        this.getAddArray5();
    }
    resetView = () => {
        window.location.reload();
    }

    piLiang = (value) => {
        const self = this;
        var submitRows = [...self.state.submitRows];
        self.setState({
            usable: true,
        });
        let messages2 = this.state.tiAddress.filter(x => x.id == value)[0];
        var orgId = value;
        var orgName = messages2.delvName;
        self.setState({defaultAddress: orgId});
        for (let record = 0; record < submitRows.length; record++) {
            submitRows[record].pickProAddress = orgName;
            submitRows[record].delvId = orgId;
        }
        self.setState({orgId: orgId, orgName: orgName, submitRows: submitRows}, () => {
            this.refreshList();
        });
    }


    showModal = () => {
        this.setState({
            confirmvisible: true,
        });
    }
    handleCancel3 = () => {
        this.setState({
            confirmvisible: false,
            confirmLoading: false,
        });
    }
//导入
    importLineData = (res) => {
        const self = this;
        var passParse = res.data;
        if (res.msg && res.msg != '' && res.msg != 'null') {
            message.warning(res.msg);
        }
        if (res.data == null) {
            message.warning('导入失败');
            return
        }

        var submitRows = [...self.state.submitRows];
        for (let i = 0; i < passParse.length; i++) {
            var x = {
                itemNum: passParse[i].productCode || '',
                count: passParse[i].count || '',
                proLine: passParse[i].proLine || '',
                productionCycle: passParse[i].productionCycle || '',
                pickProAddress: passParse[i].pickProAddress || '',
                pickProAddressId: parseInt(passParse[i].delvId) || '',
                productName: passParse[i].productName || '',
                productId: passParse[i].productId || '',
                showPrice: passParse[i].originalPrice || '',
                remark: passParse[i].remark || '',
                stockType: passParse[i].stockType || '',
                unit: passParse[i].unit || '',
                packageQuantity: passParse[i].packageQuantity || '',
                minPackageQuantity: passParse[i].minPackageQuantity || '',
                terminalPriceRate: passParse[i].terminalPriceRate || '',
                terminalUnitPrice: passParse[i].terminalUnitPrice || '',
                delvId: passParse[i].delvId || '',
                reserveLid: passParse[i].reserveLid || '',
                id: window.myTemp++,
            }
            submitRows.push(x);
        }
        self.setState({submitRows}, () => {
            if (self.state.guiShu1) {
                const getTjList = [];
                for (var i = 0; i < submitRows.length; i++) {
                    getTjList.push({
                        customerId: parseInt(this.state.orderData.thirdId),
                        proId: submitRows[i].productId,
                        purchaseId: this.state.detailData.id,
                        channelCode: this.state.channelCode,
                        flowCode: self.state.guiShu1,
                    });
                }
                giveTeJia2(getTjList).then(result => {
                    if (result.code == 200 && result.data) {
                        var submitRows = [...self.state.submitRows];
                        var tjlist = result.data;
                        submitRows.map(item => {
                            tjlist.map(itm => {
                                if (item.itemNum == itm.proCode) {
                                    if (item.terminalUnitPrice == '') {
                                        item.terminalPriceRate = itm.terminalPriceRate;
                                        item.terminalPriceRate1 = itm.terminalPriceRate;
                                        item.terminalUnitPrice = itm.terminalUnitPrice;
                                        item.terminalUnitPrice1 = itm.terminalUnitPrice;
                                    }

                                    item.offerLineId = itm.offerLineId;
                                    if (item.terminalPriceRate == '' && item.terminalUnitPrice == '') {
                                        item.specialFlag = 0;
                                    } else {
                                        item.specialFlag = 1;
                                    }
                                    if (itm.quantity != null) {
                                        item.quantity = itm.quantity;
                                        item.countMax = itm.quantity;
                                        if (item.count > itm.quantity) {
                                            item.count = itm.quantity;
                                        }
                                    } else {
                                        item.quantity = null;
                                        item.countMax = null;
                                    }
                                }
                            })
                        })
                        this.setState({...this.state.submitRows, submitRows});
                    }
                });
            }
        });
        self.refresh();
    }

    selectDian(value) {
        this.setState({dlType: value});
    }

    selectEscrow(value) {
        var orderData = this.state.orderData;
        orderData.escrowFlag = value;
        console.log(this.state.selectEscrowFlag)
        this.setState({...this.state.orderData, orderData}, () => {
            console.log(this.state.selectEscrowFlag)
        });
    }

    refresh() {
        const self = this;
        var submitRows = [...self.state.submitRows];
        var postCount = 0;
        var finishCount = 0;
        self.setState({
            usable: true,
        });
        self.setState({
            day: [],
            date: [],
            xiaFuJia: [],
            onhand: [],
            cadreRepertory: [],
            weiFaYunCount: [],
            defDeliverDay: [],
            productionCycle: [],
            productName: [],
            gfjyzr: [],
            jcxf: [],
            tehzr: [],
            tehzr2: [],
            tgzr: [],
            tihzr: [],
            tpzr: [],
            xfxzr: [],
            xszr: [],
            zzzr: [],
            reserveLineId: [],
            reserveQuantity: []
        })
        for (let t = 0; t < self.state.submitRows.length; t++) {
            var postList = {
                channelCode: self.state.orderData.channelCode,
                customerId: self.state.orderData.thirdId,
                purchaseId: self.state.detailData.id,
                pickProAddress: submitRows[t].pickProAddress || '',
                pickProAddressId: parseInt(submitRows[t].delvId) || '',
                proId: submitRows[t].productId,
                count: submitRows[t].count || 0,
                receiveAddressId: self.state.receiveAddressId,
            };
            postCount++;
            getDongList(postList).then(res => {
                if (res.code == 200 && res.data) {
                    finishCount++;
                    if (postCount == finishCount) {
                        self.setState({
                            usable: false,
                        });
                    }
                    var day = self.state.day;
                    var date = self.state.date;
                    var xiaFuJia = self.state.xiaFuJia;
                    var weiFaYunCount = self.state.weiFaYunCount;
                    var onhand = self.state.onhand;
                    var cadreRepertory = self.state.cadreRepertory;
                    var productionCycle = self.state.productionCycle;
                    var defDeliverDay = self.state.defDeliverDay;
                    var productName = self.state.productName;
                    var gfjyzr = self.state.gfjyzr;
                    var jcxf = self.state.jcxf;
                    var tehzr = self.state.tehzr;
                    var tehzr2 = self.state.tehzr2;
                    var tgzr = self.state.tgzr;
                    var tihzr = self.state.tihzr;
                    var tpzr = self.state.tpzr;
                    var xfxzr = self.state.xfxzr;
                    var xszr = self.state.xszr;
                    var zzzr = self.state.zzzr;
                    var reserveLineId = self.state.reserveLineId;
                    var reserveQuantity = self.state.reserveQuantity;
                    day[t] = res.data.day;
                    date[t] = res.data.date;
                    xiaFuJia[t] = res.data.xiaFuJia;
                    weiFaYunCount[t] = res.data.weiFaYunCount;
                    onhand[t] = res.data.onhand;
                    cadreRepertory[t] = res.data.cadreRepertory;
                    productionCycle[t] = res.data.productionCycle;
                    defDeliverDay[t] = res.data.defDeliverDay;
                    productName[t] = res.data.productName;
                    reserveLineId[t] = res.data.reserveLineId;
                    reserveQuantity[t] = res.data.reserveQuantity;
                    gfjyzr[t] = res.data.gfjyzr;
                    jcxf[t] = res.data.jcxf;
                    tehzr[t] = res.data.tehzr;
                    tehzr2[t] = res.data.tehzr2;
                    tgzr[t] = res.data.tgzr;
                    tihzr[t] = res.data.tihzr;
                    tpzr[t] = res.data.tpzr;
                    xfxzr[t] = res.data.xfxzr;
                    xszr[t] = res.data.xszr;
                    zzzr[t] = res.data.zzzr;
                    /*if (res.data.date == '待评审') {
                        submitRows[t].deliveryArrivalDate = null;
                    } else {
                        submitRows[t].deliveryArrivalDate = submitRows[t].deliveryArrivalDate && submitRows[t].capacityControl == 1 ? submitRows[t].deliveryArrivalDate : res.data.date;
                    }*/
                    submitRows[t].date = res.data.date;
                    submitRows[t].cadreRepertory = res.data.cadreRepertory;
                    submitRows[t].onhand = res.data.onhand;
                    submitRows[t].weiFaYunCount = res.data.weiFaYunCount;
                    submitRows[t].productionCycle = res.data.productionCycle;
                    submitRows[t].day = res.data.day;
                    submitRows[t].priceRate = res.data.priceRate;
                    submitRows[t].xiaFuJia = res.data.xiaFuJia;
                    submitRows[t].showPrice = res.data.listPrice;
                    if (submitRows[t].reserveLid == null || submitRows[t].reserveLid == "") {
                        if (res.data.reserveLineId != "") {
                            if (res.data.reserveQuantity < submitRows[t].count) {
                                submitRows[t].reserveLid = null;
                            } else {
                                submitRows[t].reserveLid = res.data.reserveLineId;
                            }
                        }
                    }
                    self.setState({
                        day: day,
                        date: date,
                        xiaFuJia: xiaFuJia,
                        onhand: onhand,
                        cadreRepertory: cadreRepertory,
                        weiFaYunCount: weiFaYunCount,
                        defDeliverDay: defDeliverDay,
                        productionCycle: productionCycle,
                        productName: productName,
                        reserveLineId: reserveLineId,
                        reserveQuantity: reserveQuantity,
                        gfjyzr: gfjyzr,
                        jcxf: jcxf,
                        tehzr: tehzr,
                        tehzr2: tehzr2,
                        tgzr: tgzr,
                        tihzr: tihzr,
                        tpzr: tpzr,
                        xfxzr: xfxzr,
                        xszr: xszr,
                        zzzr: zzzr,
                    }, () => {
                        self.price();
                    })
                }
            })
        }
    }

    render() {
        var self = this;
        var lines = '例如生产周期为[1,3]表示：类型为库存类的产品，有库存时生产需要1天，无库存时生产需要3天。\n' +
            '类型为非库存类的产品，显示为准确的生产天数';
        const {
            informationLi,
            visible3,
            visible4,
            opts,
            key,
            total,
            searchObj,
            selectedRowKeys5,
            selectedRowKeys3,
            addRows3,
            addRows4,
            addRows5,
            addTotal3,
            addTotal4,
            addTotal5,
            addSearchObj3,
            addSearchObj4,
            addSearchObj5,
            selectedRowKeysOutside,
            visible,
            addRows,
            addTotal,
            addSearchObj,
            orderData,
            detailData,
            optionAddress,
            remark,
            remark11,
            remark22,
            remark33,
            remark44,
            mobile,
            recipientName,
            tiAddress,
            allPrice,
            realyPrice,
            cutPrice,
            dataSource3,
            loading,
            gatherRealityAddress2,
            id6,
            defaultAddress,
            orderSubmit3,
            orderSubmit2,
            orderSubmit4,
            confirmLoading,
            confirmvisible,
            pullmanName,
            quickVisible,
            quickString,
            quickLoading,
            orgId,
            cascaderValue,
            cascaderValue2,
            tree,
            ts_disabled,
            ts_checked,
            ls_checked,
            apiFlag,
            reserveFlag,
            finishTeLoad,
            finishCount,
            postCount
        } = this.state;
        const disabledDate = (current) => {
            return current && current.valueOf() < Date.now() || current && current.valueOf() > (Date.now() + 30 * 24 * 60 * 60 * 1000);
        }
        let informationHtml = (informationLi || []).map(function (ele, key) {
            return <div className="edit_upload_information" key={key}>
                <span>{ele.fileName}</span>
                <i className="anticon anticon-delete" onClick={self.deleteInformation.bind(self, key)}></i>
            </div>
        });
        let uploadParam = toImportExcel1(
            2,
            self.state.orderData.channelCode,
            parseInt(self.state.orderData.thirdId),
            self.state.detailData.id,
            self.state.receiveAddressId,
            self.state.flowCode,
            '',
            (result) => {
                this.importLineData(result)
            }
        );
        const fenPiFaYun = {
            size: 'small',
            pagination: false,
            bordered: true,
            dataSource: this.state.dataSource2,
            columns: [
                {
                    title: '约定发货日期',
                    dataIndex: 'appointDeliveryDate',
                    render: (text, record, index) => {
                        return (<DatePicker
                            showTime
                            value={text}
                            disabledDate={disabledDate}
                            format="YYYY-MM-DD"
                            placeholder="选择时间"
                            onChange={this.handleChange.bind(this, index)}
                        />)
                    }
                },
                {
                    title: '默认发货周期（天）',
                    dataIndex: 'logisticsCycle',
                    render: (text, record, index) => {
                        return <span>{this.state.defDeliverDay[dataSource3] || 0}</span>
                    }
                },
                {
                    title: '发货数量',
                    dataIndex: 'deliveryCount',
                    render: (text, record, index) => {
                        return (<span><Input
                            defaultValue={text}
                            onChange={this.onCellChange2.bind(this, record, index)}
                        /></span>)
                    }
                },
                {
                    title: '物料名称',
                    dataIndex: 'productName',
                    render: (text, record, index) => {
                        return <span style={{whiteSpace: 'pre'}}>{this.state.productName2 || 0}</span>
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '200',
                    render: (text, record, index) => {
                        const {dataSource2} = this.state;
                        return (
                            dataSource2.length > 0 ?
                                (
                                    <a onClick={() => this.onDelete2(index)}>删除</a>
                                ) : null
                        );
                    }
                }
            ],
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 2000, y: false},
            columns: [
                {
                    title: '序号',
                    width: 50,
                    dataIndex: 'id',
                    render: (text, record, index) => {
                        return index + 1
                    }
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    width: 70,
                    render: (text) => {
                        switch (text) {
                            case '01' || '元器件':
                                return <span>{'元器件'}</span>;
                                break;
                            case '02' || '电工':
                                return <span>{'电工'}</span>;
                                break;
                            case '03' || '电表':
                                return <span>{'电表'}</span>;
                                break;
                            case '04' || '变频器':
                                return <span>{'变频器'}</span>;
                                break;
                            case '05' || '天e':
                                return <span>{'天e'}</span>;
                                break;
                            case '06' || 'TG精品':
                                return <span>{'TG精品'}</span>;
                                break;
                        }
                    }
                },
                {
                    title: '物料编码',
                    width: 120,
                    dataIndex: 'itemNum',
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text}</span>
                                {!record.specialFlag ?
                                    <Tag color="red" style={{float: 'right', cursor: 'default'}}>无特价</Tag> : null}
                                {(record.capacityControl == 1 && (record.date == "待评审" || (record.date != "待评审" && moment(record.deliveryArrivalDate ? record.deliveryArrivalDate : record.date) < moment(record.date)))) ?
                                    <Tag color="orange"
                                         style={{float: 'right', cursor: 'default'}}>产能预警</Tag> : null}
                            </div>
                        )
                    }
                },
                {
                    title: '物料描述',
                    width: 210,
                    dataIndex: 'productName'
                },
                {
                    title: '库存属性',
                    width: 90,
                    dataIndex: 'stockType',
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text}</span>
                                {record.stockType == '定制' ?
                                    <Tag color="green"
                                         style={{float: 'right', cursor: 'default'}}>定制开单</Tag> : null}
                                {(record.stockType == '库存' && record.secondStockType != null) ?
                                    <Tag color="green"
                                         style={{
                                             float: 'right',
                                             cursor: 'default'
                                         }}>{record.secondStockType}</Tag> : null}
                            </div>
                        )
                    }
                },
                {
                    title: '牌价',
                    width: 70,
                    dataIndex: 'showPrice'
                },
                // {
                // 	title: '下浮价',
                // 	dataIndex: 'xiaFuJia',
                // 	width:70,
                // 	render: (text,record,index) =>{
                // 		if (!xiaFuJia[index]) {
                // 			return (<span>{'0元'}</span>)
                // 		} else {
                // 			return (<span>{xiaFuJia[index]+'元'}</span>)
                // 		}
                // 	}
                // },  //后端说不传
                {
                    title: '单位',
                    width: 50,
                    dataIndex: 'unit'
                },
                {
                    title: '参考库存',
                    width: 100,
                    dataIndex: 'onhand',
                    render: (text, record, index) => {
                        // if (!onhand[index]) {
                        //     return (<span>{'0'}</span>)
                        // } else {
                        //     return (<span>{onhand[index]}</span>)
                        // }
                        return (<Tooltip
                            title="提货地点库存/总部库存"><span>{record.noshowOnhand ? '*' : text}/{record.noshowOnhand ? '*' : record.cadreRepertory}</span></Tooltip>);
                    }
                },
                {
                    title: '未发数量',
                    width: 90,
                    dataIndex: 'weiFaYunCount',
                    render: (text, record, index) => {
                        // if (!weiFaYunCount[index]) {
                        //     return (<span>{'0'}</span>)
                        // } else {
                        //     return (<span>{weiFaYunCount[index]}</span>)
                        // }
                        return (<span>{text || '0'}</span>)
                    }
                },
                {
                    title: '开单数量',
                    width: 100,
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        // if (this.props.params.id == 6 ) {
                        // 	return <InputNumber value={self.state.submitRows[index].count || 0}  min={0} defaultValue={0} onChange={this.onChangeInputNumber.bind(this,record,index)} disabled='true'/>
                        // } else {
                        return (<div>
                            <InputNumber value={this.state.submitRows[index].count || 0} disabled={apiFlag} min={0}
                                         onChange={this.onChangeInputNumber.bind(this, record, index)} /*disabled={(this.state.reserveHid && this.state.reserveHid != '') ? true : false}*/ />
                        </div>)
                        // }
                    }
                },
                {
                    title: '装箱数',
                    width: 70,
                    dataIndex: 'packageQuantity'
                },
                // 根据客户要求隐藏后又恢复显示
                {
                    title: '终端下浮',
                    width: 150,
                    dataIndex: 'terminalPriceRate',
                    render: (text, record, index) => <div><InputNumber
                        defaultValue={text}
                        disabled={apiFlag}
                        value={this.state.submitRows[index].terminalPriceRate || 0}
                        /*max={this.state.submitRows[index].terminalPriceRate1 || 100} min={0}*/
                        onChange={this.changeRemark1.bind(this, record, index)}/></div>
                },
                {
                    title: '终端单价(元)',
                    width: 150,
                    dataIndex: 'terminalUnitPrice',
                    render: (text, record, index) => <div><InputNumber
                        defaultValue={text}
                        // disabled={apiFlag}
                        value={this.state.submitRows[index].terminalUnitPrice || ''}
                        min={this.state.submitRows[index].terminalUnitPrice1 ? this.state.submitRows[index].terminalUnitPrice1 - 0.1 : -Infinity}
                        onChange={this.changeRemark2.bind(this, record, index)}/></div>
                },
                {
                    title: <Tooltip title='产品内盒凑整数，请按照倍数订货'>内盒凑整数</Tooltip>,
                    width: 105,
                    dataIndex: 'minPackageQuantity'
                },
                {
                    title: <Tooltip title={lines}>生产周期（天）</Tooltip>,
                    width: 135,
                    dataIndex: 'productionCycle',
                    render: (text, record, index) => {
                        if (text || ''.toString().includes("[")) {
                            //return (<span>{'0'}</span>)
                            return <Tooltip title="有库存生产需要天数/无库存天数">{text}</Tooltip>
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: <Tooltip title="例：物流周期：[2,6]代表：有库存物流发货:2天，无库存:6天">物流周期（天）</Tooltip>,
                    width: 135,
                    dataIndex: 'day',
                    render: (text, record, index) => {
                        if (text || ''.toString().includes("[")) {
                            // return (<span>{'0'}</span>)
                            return <Tooltip title="有库存物流发货天数/无库存天数">{text}</Tooltip>
                        }
                        return (<span>{text}</span>)
                    }

                },
                {
                    title: '参考到货期',
                    width: 105,
                    dataIndex: 'date',
                    render: (text, record, index) => {
                        if (typeof text == 'string') {
                            return text
                        } else {
                            return (<span>{text || '0'}</span>)
                        } /*else {
                            return (<span>{date[index]}</span>)
                        }*/
                    }
                },
                {
                    title: '预计到货期',
                    width: 105,
                    dataIndex: 'predictArrivalDate',
                    render: text => {
                        if (typeof text == 'string') {
                            return text
                        } else {
                            text ? new Date(text).format('yyyy-MM-dd') : ''
                        }
                    }
                },
                {
                    title: '要求交期',
                    width: 125,
                    dataIndex: 'deliveryArrivalDate',
                    render: (text, record, index) =>
                        <Tooltip title="启用产能控制的产品可修改交期">
                            <div>
                                <DatePicker
                                    onChange={self.deliveryTimeonChange.bind(this, index)}
                                    format="YYYY-MM-DD"
                                    value={text ? moment(text) : null}
                                    disabled={record.capacityControl != 1}
                                />
                            </div>
                        </Tooltip>

                },
                {
                    title: '备注',
                    width: 150,
                    dataIndex: 'remark',
                    render: (text, record, index) => <div><Input
                        defaultValue={text}
                        maxLength={100}/*disabled={!this.state.guiShu1 ? true : false}*/
                        value={this.state.submitRows[index].remark || ''}
                        onChange={this.changeRemark.bind(this, record, index)}/></div>
                },
                {
                    title: '提货地点',
                    width: 150,
                    dataIndex: 'pickProAddress',
                    render: (text, record, index) => {
                        return <Select
                            style={{width: 150}}
                            value={this.state.submitRows[index].pickProAddress}
                            onSelect={this.addressChange2.bind(this)}
                            disabled={id6 || reserveFlag}
                            // disabled={!this.state.guiShu1 ? true : false}
                        >
                            {(tiAddress || '').map(function (ele, itm, record) {
                                return <Option key={itm} recordIndex={index}
                                               value={ele.id + ''}>{ele.delvName}</Option>;
                            })}
                        </Select>
                    }
                },
                /*{
                    title: <Tooltip title='该功能用于产品分批发货，可自定义每一批产品的发货时间'>分批发运</Tooltip>,
                    dataIndex: 'orderProductPartList',
                    width: 85,
                    render: (text, record, index) => {
                        return (<div>
                            <img src={fenPi} alt='' title='分批发运' onClick={this.openModal.bind(this, record, index)}
                                 style={{width: 20}}/>
                            <Modal
                                visible={modalVisible}
                                title="分批发运"
                                onCancel={this.handleCancel2}
                                recordIndex={index}
                                maskClosable={false}
                                width={1000}
                                style={{top: 20}}
                                footer={null}
                            >
                                <div>
                                    <Button onClick={this.handleAdd2}>添加行</Button>
                                    <Button onClick={this.saveFenPi.bind(this, record, index)}
                                            style={{marginLeft: 10}}>确认添加</Button>
                                    {/!*<Button onClick={this.deleteFenPi} style={{marginLeft: 10}}>删除</Button>*!/}
                                    <Table {...fenPiFaYun} bordered style={{marginTop: 10}}/>

                                </div>
                            </Modal>
                        </div>)
                    }
                },*/

            ],
            rows: this.state.submitRows,
            rowSelection: {
                selectedRowKeys: selectedRowKeysOutside,
                onChange: self.onOutsideSelectChange,
                getCheckboxProps: record => ({
                    disabled: (record.stockType != '退市' && (id6 || apiFlag))
                })
            }
        };
        const addProps = {
            rowKey: 'id',
            loading: loading,
            pageParam: {
                total: addTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                // {
                // 	title:'图片',
                // 	dataIndex:'picUrl',
                // 	width:120,
                // 	render: text => text ? <div><img src={src+text} style={{height:50}}/></div> : ''
                // },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 90,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    width: 220,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>)
                        } else {
                            return (<span>{text}</span>)
                        }
                    }
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice',
                    width: 60,
                    render: (text, record, index) => {
                        if (record.itemManagerFlag == '' || record.itemManagerFlag == null || record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>)
                        } else {
                            return (<span style={{color: '#d61518', height: 50}}>{'¥' + text}</span>)
                        }
                    }
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType',
                    width: 60,
                },
                {
                    title: '物料类别',
                    dataIndex: 'proBigName',
                    width: 220,
                    render: (text, record, index) => {
                        return <span>{`${record.proBigName}/${record.proMiddleName}/${record.proDetailName}`}</span>
                    }
                },
                // {
                //     title: '产能',
                //     dataIndex: 'capacityStatus',
                //     width: 40,
                //     render: (text, record, index) => {
                //         let a;
                //         switch (text) {
                //             case "0":
                //                 a = <span>🩶</span>;
                //                 break;
                //             case "1":
                //                 a = <span>💚</span>;
                //                 break;
                //             case "2":
                //                 a = <span>💛</span>;
                //                 break;
                //             case "3":
                //                 a = <span>❤️</span>;
                //                 break;
                //             default:
                //                 a = <span>🩶</span>;
                //                 break;
                //         }
                //         return <Tooltip placement="topLeft" title="💚正常;💛紧张;❤️严重不足;🩶无法获取"> {a} </Tooltip>
                //     },
                // },
                {
                    title: '历史开单量',
                    dataIndex: 'historyCount',
                    width: 70,
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 150,
                    render: (text, record, index) => {
                        if (record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span>无开单权限，请联系【价格管理部】申请开通下单权限</span>)
                        } else if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (
                                <span>经公司高层领导决定，对专属定制物料进行全面管控，若有需求，请发起定制申请</span>)
                        } else {
                            return (<Button style={{background: '#red'}} icon="plus"
                                            onClick={this.addSave.bind(this, record, index)}>添加</Button>)
                        }
                    }
                }
            ],
            rows: addRows,
            /*rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                onSelect: this.onSelectRadio.bind(this),
                type: 'checkbox',
                // radio:false
            }*/
        };
        const addProps3 = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal3,
                current: addSearchObj3.p,//当前页码
                pageSize: addSearchObj3.s,//当前分页数
                onChange: this.addPageChange3
            },
            columns: [
                {
                    title: '流程编码',
                    dataIndex: 'specCode',
                    width: 100
                },
                {
                    title: '项目名称',
                    dataIndex: 'projectName',
                    width: 100,
                },
                {
                    title: '开始日期',
                    dataIndex: 'startDate',
                    width: 100,
                    render: text => new Date(text).format('yyyy-MM-dd')
                },
                {
                    title: '结束日期',
                    dataIndex: 'endDate',
                    width: 100,
                    render: text => new Date(text).format('yyyy-MM-dd')
                },
                {
                    title: '承接业务员',
                    dataIndex: 'userName',
                    width: 100,
                },
                {
                    title: '终端单位',
                    dataIndex: 'zdCompany',
                    width: 100,
                },
                {
                    title: '盘厂/行业客户',
                    dataIndex: 'pcCust',
                    width: 100,
                }
            ],
            rows: addRows3,
            rowSelection: {
                selectedRowKeys: selectedRowKeys3,
                onChange: this.onSelectChange3,
                onSelect: this.onSelectRadio3,
                type: 'radio',
                // radio:false
            }
        };
        const addProps4 = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal4,
                current: addSearchObj4.p,//当前页码
                pageSize: addSearchObj4.s,//当前分页数
                onChange: this.addPageChange4
            },
            columns: [
                {
                    title: '具体物料规格',
                    children: [{
                        title: '对应物料编码',
                        dataIndex: 'proCode',
                        width: 100
                    },
                        {
                            title: '具体物料描述',
                            dataIndex: 'proDesc',
                            width: 100,
                        },
                        {
                            title: '特价数量',
                            dataIndex: 'count',
                            width: 100,
                        },
                        {
                            title: '累计开单数量',
                            dataIndex: 'orderQty',
                            width: 100,
                        },
                        {
                            title: '面价',
                            dataIndex: 'listPrice',
                            width: 100,
                        },
                        {
                            title: '合同价',
                            dataIndex: 'price',
                            width: 100,
                        }, {
                            title: '预计销量(万元)',
                            dataIndex: 'amount',
                            width: 100,
                        }, {
                            title: '操作',
                            dataIndex: '',
                            width: 100,
                            render: (text, record, index) => {
                                if (record.proCode != "" && record.proCode != null) {
                                    return (<Button style={{background: '#red'}} icon="plus"
                                                    onClick={this.openAdd.bind(this, record.proCode)}>添加</Button>)
                                }
                            }
                        }]
                },
                {
                    title: '整体框架协议',
                    children: [{
                        title: '产品类别',
                        dataIndex: 'categoryDesc',
                        width: 100,
                    },
                        {
                            title: '类别编码',
                            dataIndex: 'categoryCode',
                            width: 100,
                        },
                        {
                            title: '合同下浮比例',
                            dataIndex: 'lowerRate',
                            width: 100,
                        }]
                }
            ],
            rows: addRows4,
        };
        const addProps5 = {
            rowKey: 'RN',
            loading: false,
            pageParam: {
                total: addTotal5,
                current: addSearchObj5.p,//当前页码
                pageSize: addSearchObj5.s,//当前分页数
                onChange: this.addPageChange5
            },
            columns: [
                {
                    title: '合同编号',
                    dataIndex: 'contractOrderCode',
                    width: 100
                },
                {
                    title: '合同名称',
                    dataIndex: 'contractOrderName',
                    width: 100,
                },
                {
                    title: '合同可用额',
                    dataIndex: 'kyAmount',
                    width: 100,
                },
                {
                    title: '质保金',
                    dataIndex: 'guaranteeQuality',
                    width: 100,
                },
                {
                    title: '质保金到期',
                    dataIndex: 'guaranteeQualityDate',
                    width: 100,
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : ''
                }
            ],
            rows: addRows5,
            rowSelection: {
                selectedRowKeys: selectedRowKeys5,
                onChange: this.onSelectChange5,
                onSelect: this.onSelectRadio5,
                type: 'radio',
            }
        };
        var orderCategory;
        if (orderData.Type == 'Y1') {
            orderCategory = '常规订单'
        }
        if (orderData.Type == 'Y2') {
            orderCategory = '项目订单'
        }
        if (orderData.Type == 'Y3') {
            orderCategory = '合作伙伴订单'
        }
        if (this.props.params.id == 6 || this.props.params.id == 9) {
            orderCategory = '项目订单'
        }

        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button onClick={this.goBack.bind(this)} style={{float: 'right'}}>取消</Button>
                {/*<Tooltip title="无法保存时，请检查订单内容是否填写完整，如已添加物料行，请尝试修改开单数量。"
                         placement='bottom'
                         arrowPointAtCenter
                         visible={this.state.usable}
                ><Button style={{marginLeft: 10, display: orderSubmit3, float: 'right'}} onClick={this.createHandler2}
                         disabled={this.state.usable}>保存</Button></Tooltip>*/}
                <Button style={{marginLeft: 10, display: orderSubmit3, float: 'right'}} onClick={this.createHandler2}
                        disabled={this.state.usable || finishTeLoad}>保存</Button>
                <Button onClick={this.showModal}
                        style={{background: '#d61518', color: '#fff', display: orderSubmit4, float: 'right'}}
                        disabled={this.state.usable || finishTeLoad}>提交</Button>
                <Progress type="circle" percent={!this.state.usable ? 100 : (finishCount / postCount * 100).toFixed(0)}
                          width={30}
                          style={{float: 'right', display: orderSubmit4}}> </Progress>
                <Modal title="注意"
                       visible={confirmvisible}
                       onOk={this.createHandler}
                       confirmLoading={confirmLoading}
                       onCancel={this.handleCancel3}
                >
                    <p>{"提交后将无法修改、删除订单，确认提交订单："}{this.state.getProCode}{"？请务必仔细核对订单数量、金额是否正确，避免输入错误影响产品发货"}</p>
                    <p style={{color: '#d61518'}}>{this.state.orderData.orderSource == "BPM" ? "此订单为业务员申请的特批订单，物料信息不允许修改，请在提交前仔细核对" : ""}</p>
                    {/*<p style={{color: '#d61518'}}>{"注意：如果存在无特价产品，订单将自动转为人工审核"}</p>*/}
                </Modal>
                <Button onClick={this.createHandler.bind(this, `${2}`)} style={{
                    background: '#d61518',
                    color: '#fff',
                    marginLeft: 10,
                    display: orderSubmit2,
                    float: 'right'
                }} disabled={this.state.usable}>提交客户审核</Button>
                {/*<Button onClick={this.resetView} style={{background:'#d61518', color: '#fff',float:'right'}}>重置</Button>*/}
            </DmsTab>
            <div className="dms-table-box">
                <div className="Card-P">
                    <Row>
                        <Col span={6}>
                            <Card title="订单信息" bordered={false} noHovering={true}>
                                <p><label>要货单号：</label>
                                    <span>{this.state.getProCode || '-'}</span></p>
                                <p><label>订单编号：</label>
                                    <span>-</span></p>
                                <p><label>订单日期：</label>
                                    <span>{moment(parseInt(detailData.createdDate)).format('YYYY-MM-DD') || '-'}</span>
                                </p>
                                <p><label>订单类型：</label>
                                    <span>{orderCategory}</span></p>
                                <p><label>状态：</label>
                                    <span>{this.state.status || '-'}</span></p>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card title="客户资料" bordered={false} noHovering={true}>
                                <p><label>经销商编号：</label>
                                    <span>{detailData.cusCode}</span></p>
                                <p><label>经销商名称：</label>
                                    <span>{detailData.cusName}</span></p>
                                <p><label>购货单位：</label>
                                    <span>{orderData.PurchaseUnit}</span></p>
                                <p><label>渠道：</label>
                                    <span>{orderData.channel}</span></p>
                                <p>
                                    {/*{(this.state.channelCode == 'PC' || this.state.channelCode == 'FX') &&
                                    <lable>承接</lable>}*/}
                                    <label>承接业务员：</label>
                                    <Input value={remark44} style={{width: 175}} onChange={this.remarkChange4}/></p>
                                {/*{(this.state.channelCode == 'PC' || this.state.channelCode == 'FX') &&*/}
                                <p>
                                    <label>拉动业务员：</label>
                                    <Input value={pullmanName} style={{width: 175}}
                                           onChange={this.pullmanNameChange.bind(this)}/>
                                </p>
                                {/*}*/}
                                <p><label>整单发货：</label>
                                    <span><Select value={this.state.wholeDelivery} style={{width: 188}}
                                                  onChange={this.wholeDeliveryChange.bind(this)}>
								<Option key={1} value={'Y'}>{'是'}</Option>
								<Option key={2} value={'N'}>{'否'}</Option>
                                </Select></span></p>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card title="信用情况" bordered={false} noHovering={true}>
                                <p><label>可用余额：</label>
                                    <span>{orderData.sxeAmount}</span></p>
                                <p><label>开单折扣率：</label>
                                    <span>{orderData.defDiscount}</span></p>
                                <p><label>付款方式：</label>
                                    <span>{orderData.pay}</span></p>
                                <p><label>质保金：</label>
                                    <span>{this.state.guaranteeQuality || '-'}</span></p>
                                <p><label>合同/订单名称：</label>
                                    <span><Input onClick={this.openCity3.bind(this)} style={{width: 150}}
                                                 value={this.state.contractOrderName}/></span></p>
                                <p><label>价格单号：</label>
                                    <span><Input onClick={this.openCity2.bind(this)} style={{width: 184}}
                                                 disabled={apiFlag}
                                                 value={this.state.guiShu1} /*disabled={this.state.teJiaShow}*//></span>
                                </p>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card title="项目订单属性" bordered={false} noHovering={true}>
                                <p><label>项目合作：</label>
                                    <span>
							<Select value={this.state.projectCooperation} style={{width: 184}}
                                    onChange={this.projectChange.bind(this)}>
								<Option key={1} value={'与建筑行业合作'}>{'与建筑行业合作'}</Option>
								<Option key={2} value={'与工业合作'}>{'与工业合作'}</Option>
								<Option key={3} value={'与电力合作'}>{'与电力合作'}</Option>
                                <Option key={4} value={'与盘厂合作'}>{'与盘厂合作'}</Option>
							</Select>
						</span></p>
                                <p><label>终端单位名称：</label>
                                    <Input value={remark11} style={{width: 157}} onChange={this.remarkChange1}/></p>
                                <p><label>结算对应号：</label>
                                    <Input value={remark22} style={{width: 170}} onChange={this.remarkChange2}/></p>
                                <p><label>终端附加信息：</label>
                                    <Input value={remark33} style={{width: 156}} onChange={this.remarkChange3}/></p>
                                <p><label>出库单显示单价：</label>
                                    <span>
							<Select value={this.state.deliveryShowprice} style={{width: 143}}
                                    onChange={this.deliveryShowpriceChange.bind(this)}>
								<Option key={1} value={'Y'}>{'是'}</Option>
								<Option key={2} value={'N'}>{'否'}</Option>
							</Select>
                                    </span></p>
                                {this.state.channelCode == 'DL' && <p>
                                    <label>电力业务类别：</label>
                                    <span>
							<Select
                                style={{width: 156}}
                                value={this.state.dlType}
                                onSelect={this.selectDian.bind(this)}
                                disabled={this.state.channelCode == 'DL' ? false : true}
                            >
								<Option key={1} value={'A'}>{'电力配套业务'}</Option>
								<Option key={2} value={'B'}>{'电力招投标业务'}</Option>
								<Option key={3} value={'C'}>{'电力业扩业务'}</Option>
							</Select>
						</span></p>}
                                {/*{(this.state.channelCode == 'PC' || this.state.channelCode == 'FX') && */}
                                <p>
                                    <label>业务拉动渠道：</label>
                                    <span>
                                    {/*之前的判断逻辑加上选中特价后锁定下拉框（但是目前直接将拉动渠道锁定，设置成非手选项）
                                    disabled={this.state.channelCode == 'PC' && this.state.pullChannel == null ? false : true}>*/}
                                        <Select value={this.state.pullChannel} style={{width: 156}}
                                                onChange={this.pullChannelChange.bind(this)}
                                                disabled={true}>
                                    <Option key={1} value={'CT'}>{'工业'}</Option>
                                    <Option key={2} value={'DL'}>{'电力'}</Option>
                                    <Option key={3} value={'GMJ'}>{'建筑行业'}</Option>
                                    <Option key={4} value={'PC'}>{'盘厂'}</Option>
                                    </Select>
                                    </span></p>
                                {/*}*/}
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <hr style={{marginBottom: '7px'}}/>
                            <Card bordered={false} noHovering={true}>
                                <p><label>实际收货地址：</label>
                                    <Tooltip
                                        title="收货地址新增、修改或失效，请联系总部物流周春霞"
                                        placement='top'
                                        arrowPointAtCenter
                                    ><span>
							<Select
                                showSearch
                                optionFilterProp="children"
                                style={{width: 600}}
                                value={gatherRealityAddress2}
                                dropdownMatchSelectWidth={false}
                                onSelect={this.addressChange.bind(this)}
                                disabled={this.state.shouHuoShow}
                            >
								{(optionAddress || '').map(function (ele, itm) {
                                    return <Option key={itm} value={ele.id + ''}>{ele.detailAddress}</Option>;
                                })}
							</Select>
                                    </span></Tooltip></p>
                                <p><label>备注：</label>
                                    <Input value={remark} style={{width: 655}} maxLength={100}
                                           onChange={this.remarkChange}/></p>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <hr style={{marginBottom: '7px'}}/>
                            <Card bordered={false} noHovering={true}>
                                <p><label>联系人：</label>
                                    <span>{recipientName || '-'}</span>
                                    <label style={{paddingLeft: '30px'}}>联系电话：</label>
                                    <span>{mobile || '-'}</span></p>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <hr style={{marginBottom: '7px'}}/>
                            <Card bordered={false} noHovering={true}>
                                <p><label>是否托管订单：</label>
                                    <span><Select
                                        style={{width: 156}}
                                        value={this.state.orderData.escrowFlag}
                                        onSelect={this.selectEscrow.bind(this)}
                                        disabled={this.state.selectEscrowFlag == 'N'}
                                    >
								<Option key={1} value={1}>{'是'}</Option>
								<Option key={2} value={0}>{'否'}</Option>
							</Select></span></p>
                            </Card>
                        </Col>
                        {/*					<Col span={6} style={{marginTop: 10}}>
						<label>招投标合同扫描件：</label>
				                  <Upload {...informationProps} >
				                  	<div style={{padding: '12px', background: '#fff'}}>
								<Button><Icon type="upload" /> 上传扫描件</Button>{informationHtml}
							</div>
						</Upload>
					</Col>*/}
                    </Row>
                </div>
            </div>
            <div>
                <DmsTab className="white-bg no-border"
                        options={['订单商品（无特价：代表产品不在特价中，请仔细核对产品的系列是否与特价中的系列一致）']}
                        defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 8}}>
                        <Button style={{float: 'left'}} onClick={this.searchHandler}
                                disabled={id6 || apiFlag}>新增</Button>
                        <Button style={{marginLeft: 10, float: 'left'}} onClick={this.deleteHandler.bind(this)}
                                disabled={this.state.usable || finishTeLoad}
                        >删除</Button>
                        <Button style={{float: 'left', marginLeft: 10}} onClick={this.downloadChange.bind(this)}
                                disabled={id6 || apiFlag}>下载模版</Button>
                        <Upload {...uploadParam}>
                            <Button style={{marginLeft: 10}} disabled={id6 || apiFlag}>
                                <Icon type="upload"/>导入
                            </Button>
                        </Upload>
                        <Button style={{float: 'left', marginLeft: 10}} onClick={this.quickHandler}
                                disabled={id6 || (orgId == null) || apiFlag}>快捷录入</Button>
                        <label style={{marginLeft: 10}}>批量设置提货地点：</label>
                        <Tooltip
                            title="1、开通总部提货，请联系总部物流周春霞。2、预订单转化的订单，自动绑定提货地点，请核对每一行物料后的提货地点"
                            placement='top'
                            arrowPointAtCenter
                        ><span style={{marginLeft: 10}}>
							<Select
                                value={defaultAddress}
                                onChange={this.piLiang.bind(this)}
                                style={{width: 170}}
                                disabled={id6 || reserveFlag || apiFlag}
                            >
							        {(tiAddress || '').map(function (ele, itm) {
                                        return <Option key={itm} value={ele.id + ''}>{ele.delvName}</Option>;
                                    })}
						        </Select>
                        </span></Tooltip>
                    </div>
                    <TableView {...tableViewProps}/>
                    <div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">{'商品总金额：￥' + allPrice}</span></p>
                        <p><span className="right">{'优惠金额：￥' + cutPrice}</span></p>
                        <p><span className="right">{'实际总金额：￥' + realyPrice}</span></p>
                    </div>
                </div>

            </div>

            <Modal
                visible={visible}
                title={<span>选择物料（支持Enter回车查询，<span
                    style={{color: 'red'}}> 搜索不到产品？请尝试勾选退市产品</span>）</span>}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={1200}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>物料名称/编码：</label><Input style={{width: 250}}
                                                                              value={this.state.name}
                                                                              onChange={this.nameChange.bind(this)}
                                                                              onKeyPress={this.keypress}/></Col>
                            <Col span={5}><label>产品分类：</label>
                                <Cascader style={{width: '130px'}} options={tree}
                                          value={cascaderValue}
                                          onChange={this.CascaderChange.bind(this)}
                                          onClick={this.CascaderClick.bind(this)}
                                          displayRender={this.CascaderRender.bind(this)}
                                          placeholder=""
                                          popupClassName="popupClass"
                                          showSearch={{filter: this.CascaderFilter}}
                                /></Col>
                            <Col span={4}><label>库存属性：</label>
                                <Select defaultValue="" style={{width: 100}} onChange={this.stockChange}>
                                    <Option value="">全部</Option>
                                    <Option value="0">库存</Option>
                                    <Option value="1">非库存</Option>
                                    <Option value="2">定制</Option>
                                    <Option value="3">专属定制</Option>
                                </Select>
                            </Col>
                            <Col span={2}><Checkbox onChange={this.tsChange}
                                                    disabled={ts_disabled}
                                                    checked={ts_checked}>退市产品</Checkbox></Col>
                            <Col span={3}><Tooltip placement="topLeft"
                                                   title="从您历史一年的开单产品中搜索"
                                                   arrowPointAtCenter><Checkbox onChange={this.lsChange}
                                                                                checked={ls_checked}>历史开单产品</Checkbox></Tooltip></Col>
                            <Col span={2}><Button onClick={this.getAddArray.bind(this)}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            {/*<Button onClick={this.addSaveHandler.bind(this,`${1}`)}>确认并继续</Button>*/}
                            {/*<Button onClick={this.addSaveHandler}>确认</Button>*/}
                        </Col>
                    </Row>
                </div>
            </Modal>
            <Modal
                visible={visible3}
                title="选择价格单号"
                // onOk={this.handleOk3}
                onCancel={this.handleCancel4}
                maskClosable={false}
                width={1200}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={6}><label>流程编码：</label><Input style={{width: 200}}
                                                                         value={this.state.specCode}
                                                                         onChange={this.guiShuChange1}/></Col>
                            <Col span={6}><label>项目名称：</label><Input style={{width: 200}}
                                                                         value={this.state.projectName}
                                                                         onChange={this.guiShuChange2}/></Col>
                            <Col span={6}><label>产品分类：</label>
                                <Cascader style={{width: '130px'}} options={tree}
                                          value={cascaderValue2}
                                          onChange={this.CascaderChange2.bind(this)}
                                          onClick={this.CascaderClick.bind(this)}
                                          displayRender={this.CascaderRender.bind(this)}
                                          placeholder=""
                                          popupClassName="popupClass"
                                          showSearch={{filter: this.CascaderFilter}}
                                /></Col>
                            <Col span={6}><Button onClick={this.getAddArray3}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps3} bordered style={{marginTop: 10}}/>
                        <TableView {...addProps4} bordered/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button type="primary"
                                    onClick={this.addSaveHandler3}>确认</Button><span>&nbsp;&nbsp;&nbsp;</span>
                            <Button type="dashed" onClick={this.clearSaveHandler3}>清除价格单号</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>
            <Modal
                visible={visible4}
                title="选择合同"
                // onOk={this.handleOk3}
                onCancel={this.handleCancel5}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>合同编号：</label><Input style={{width: 200}}
                                                                         value={this.state.contractOrderCode}
                                                                         onChange={this.guiShuChange10}/></Col>
                            <Col span={8}><label>合同名称：</label><Input style={{width: 200}}
                                                                         value={this.state.contractOrderName2}
                                                                         onChange={this.guiShuChange20}/></Col>
                            <Col span={8}><Button onClick={this.getAddArray5}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps5} bordered style={{marginTop: 10}}/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.addSaveHandler4}>确认</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal visible={quickVisible}
                   title={"快捷录入"}
                   onOk={this.handleOk6}
                   onCancel={this.handleCancel6}
                   confirmLoading={quickLoading}
                   maskClosable={false} width={500}
            >
                <div><TextArea rows={10} placeholder='按[物料编码，数量]或[物料编码 数量]格式录入，多个换行录入'
                               value={quickString}
                               onChange={this.quickChange}></TextArea></div>
            </Modal>
        </div>
    }
}

export default withRouter(CustomOrderAdd);



// WEBPACK FOOTER //
// ./src/routes/order/addProject.js